// Code generated by gen-relref. DO NOT EDIT.

export type File =
    '/' |
    '/100' |
    '/100/index' |
    '/100/index.html' |
    '/50' |
    '/50/index' |
    '/50/index.html' |
    '/75' |
    '/75/index' |
    '/75/index.html' |
    '/_index' |
    '/_index.html' |
    '/account-settings' |
    '/account-settings.html' |
    '/all-pricing' |
    '/all-pricing.html' |
    '/american-made-challenge-coins' |
    '/american-made-challenge-coins/index' |
    '/american-made-challenge-coins/index.html' |
    '/american-made-free-quote' |
    '/american-made-free-quote.html' |
    '/american-made-free-quote/details' |
    '/american-made-free-quote/details.html' |
    '/american-made-free-quote/in-depth' |
    '/american-made-free-quote/in-depth.html' |
    '/american-made-free-quote/review' |
    '/american-made-free-quote/review.html' |
    '/american-made-free-quote/thank-you' |
    '/american-made-free-quote/thank-you.html' |
    '/american-made-free-quote/upload' |
    '/american-made-free-quote/upload.html' |
    '/american-made-rush-pins' |
    '/american-made-rush-pins/index' |
    '/american-made-rush-pins/index.html' |
    '/attachments' |
    '/attachments/index' |
    '/attachments/index.html' |
    '/blog' |
    '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t' |
    '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t/index' |
    '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t/index.md' |
    '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3' |
    '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3/index' |
    '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3/index.md' |
    '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms' |
    '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms/index' |
    '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms/index.md' |
    '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht' |
    '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht/index' |
    '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht/index.md' |
    '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6' |
    '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6/index' |
    '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6/index.md' |
    '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt' |
    '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt/index' |
    '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt/index.md' |
    '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus' |
    '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus/index' |
    '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus/index.md' |
    '/blog/_index' |
    '/blog/_index.html' |
    '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94' |
    '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94/index' |
    '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94/index.md' |
    '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1' |
    '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1/index' |
    '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1/index.md' |
    '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6' |
    '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6/index' |
    '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6/index.md' |
    '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63' |
    '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63/index' |
    '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63/index.md' |
    '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da' |
    '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da/index' |
    '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da/index.md' |
    '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo' |
    '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo/index' |
    '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo/index.md' |
    '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd' |
    '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd/index' |
    '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd/index.md' |
    '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5' |
    '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5/index' |
    '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5/index.md' |
    '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz' |
    '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz/index' |
    '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz/index.md' |
    '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t' |
    '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t/index' |
    '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t/index.md' |
    '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d' |
    '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d/index' |
    '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d/index.md' |
    '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44' |
    '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44/index' |
    '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44/index.md' |
    '/blog/baseball-pins-made-faster-ngbm3jrr160m' |
    '/blog/baseball-pins-made-faster-ngbm3jrr160m/index' |
    '/blog/baseball-pins-made-faster-ngbm3jrr160m/index.md' |
    '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya' |
    '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya/index' |
    '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya/index.md' |
    '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy' |
    '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy/index' |
    '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy/index.md' |
    '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9' |
    '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9/index' |
    '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9/index.md' |
    '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss' |
    '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss/index' |
    '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss/index.md' |
    '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono' |
    '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono/index' |
    '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono/index.md' |
    '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h' |
    '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h/index' |
    '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h/index.md' |
    '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut' |
    '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut/index' |
    '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut/index.md' |
    '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35' |
    '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35/index' |
    '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35/index.md' |
    '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m' |
    '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m/index' |
    '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m/index.md' |
    '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi' |
    '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi/index' |
    '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi/index.md' |
    '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj' |
    '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj/index' |
    '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj/index.md' |
    '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej' |
    '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej/index' |
    '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej/index.md' |
    '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0' |
    '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0/index' |
    '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0/index.md' |
    '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl' |
    '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl/index' |
    '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl/index.md' |
    '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79' |
    '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79/index' |
    '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79/index.md' |
    '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j' |
    '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j/index' |
    '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j/index.md' |
    '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh' |
    '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh/index' |
    '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh/index.md' |
    '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj' |
    '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj/index' |
    '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj/index.md' |
    '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3' |
    '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3/index' |
    '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3/index.md' |
    '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58' |
    '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58/index' |
    '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58/index.md' |
    '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs' |
    '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs/index' |
    '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs/index.md' |
    '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9' |
    '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9/index' |
    '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9/index.md' |
    '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8' |
    '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8/index' |
    '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8/index.md' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9/index' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9/index.md' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26/index' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26/index.md' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j/index' |
    '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j/index.md' |
    '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7' |
    '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7/index' |
    '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7/index.md' |
    '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag' |
    '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag/index' |
    '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag/index.md' |
    '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk' |
    '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk/index' |
    '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk/index.md' |
    '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa' |
    '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa/index' |
    '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa/index.md' |
    '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk' |
    '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk/index' |
    '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk/index.md' |
    '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx' |
    '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx/index' |
    '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx/index.md' |
    '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i' |
    '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i/index' |
    '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i/index.md' |
    '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i' |
    '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i/index' |
    '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i/index.md' |
    '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe' |
    '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe/index' |
    '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe/index.md' |
    '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41' |
    '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41/index' |
    '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41/index.md' |
    '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj' |
    '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj/index' |
    '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj/index.md' |
    '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx' |
    '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx/index' |
    '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx/index.md' |
    '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr' |
    '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr/index' |
    '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr/index.md' |
    '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde' |
    '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde/index' |
    '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde/index.md' |
    '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr' |
    '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr/index' |
    '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr/index.md' |
    '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h' |
    '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h/index' |
    '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h/index.md' |
    '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac' |
    '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac/index' |
    '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac/index.md' |
    '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt' |
    '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt/index' |
    '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt/index.md' |
    '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5' |
    '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5/index' |
    '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5/index.md' |
    '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx' |
    '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx/index' |
    '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx/index.md' |
    '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2' |
    '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2/index' |
    '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2/index.md' |
    '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy' |
    '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy/index' |
    '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy/index.md' |
    '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c' |
    '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c/index' |
    '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c/index.md' |
    '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei' |
    '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei/index' |
    '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei/index.md' |
    '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18' |
    '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18/index' |
    '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18/index.md' |
    '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm' |
    '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm/index' |
    '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm/index.md' |
    '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32' |
    '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32/index' |
    '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32/index.md' |
    '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo' |
    '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo/index' |
    '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo/index.md' |
    '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68' |
    '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68/index' |
    '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68/index.md' |
    '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99' |
    '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99/index' |
    '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99/index.md' |
    '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02' |
    '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02/index' |
    '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02/index.md' |
    '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek' |
    '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek/index' |
    '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek/index.md' |
    '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt' |
    '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt/index' |
    '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt/index.md' |
    '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5' |
    '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5/index' |
    '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5/index.md' |
    '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc' |
    '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc/index' |
    '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc/index.md' |
    '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l' |
    '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l/index' |
    '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l/index.md' |
    '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0' |
    '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0/index' |
    '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0/index.md' |
    '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884' |
    '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884/index' |
    '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884/index.md' |
    '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o' |
    '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o/index' |
    '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o/index.md' |
    '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1' |
    '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1/index' |
    '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1/index.md' |
    '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh' |
    '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh/index' |
    '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh/index.md' |
    '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki' |
    '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki/index' |
    '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki/index.md' |
    '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e' |
    '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e/index' |
    '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e/index.md' |
    '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py' |
    '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py/index' |
    '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py/index.md' |
    '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in' |
    '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in/index' |
    '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in/index.md' |
    '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6' |
    '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6/index' |
    '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6/index.md' |
    '/blog/custom-attraction-lapel-pins-ngbm191bx0xc' |
    '/blog/custom-attraction-lapel-pins-ngbm191bx0xc/index' |
    '/blog/custom-attraction-lapel-pins-ngbm191bx0xc/index.md' |
    '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv' |
    '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv/index' |
    '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv/index.md' |
    '/blog/custom-challenge-coin-01-ngbm716lar18' |
    '/blog/custom-challenge-coin-01-ngbm716lar18/index' |
    '/blog/custom-challenge-coin-01-ngbm716lar18/index.md' |
    '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi' |
    '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi/index' |
    '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi/index.md' |
    '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl' |
    '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl/index' |
    '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl/index.md' |
    '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr' |
    '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr/index' |
    '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr/index.md' |
    '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b' |
    '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b/index' |
    '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b/index.md' |
    '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6' |
    '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6/index' |
    '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6/index.md' |
    '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u' |
    '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u/index' |
    '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u/index.md' |
    '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33' |
    '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33/index' |
    '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33/index.md' |
    '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni' |
    '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni/index' |
    '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni/index.md' |
    '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas' |
    '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas/index' |
    '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas/index.md' |
    '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq' |
    '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq/index' |
    '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq/index.md' |
    '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk' |
    '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk/index' |
    '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk/index.md' |
    '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86' |
    '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86/index' |
    '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86/index.md' |
    '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd' |
    '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd/index' |
    '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd/index.md' |
    '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe' |
    '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe/index' |
    '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe/index.md' |
    '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w' |
    '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w/index' |
    '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w/index.md' |
    '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc' |
    '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc/index' |
    '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc/index.md' |
    '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z' |
    '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z/index' |
    '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z/index.md' |
    '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50' |
    '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50/index' |
    '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50/index.md' |
    '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat' |
    '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat/index' |
    '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat/index.md' |
    '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo' |
    '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo/index' |
    '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo/index.md' |
    '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4' |
    '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4/index' |
    '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4/index.md' |
    '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv' |
    '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv/index' |
    '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv/index.md' |
    '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b' |
    '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b/index' |
    '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b/index.md' |
    '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu' |
    '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu/index' |
    '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu/index.md' |
    '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh' |
    '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh/index' |
    '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh/index.md' |
    '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf' |
    '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf/index' |
    '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf/index.md' |
    '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo' |
    '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo/index' |
    '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo/index.md' |
    '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu' |
    '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu/index' |
    '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu/index.md' |
    '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq' |
    '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq/index' |
    '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq/index.md' |
    '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib' |
    '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib/index' |
    '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib/index.md' |
    '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx' |
    '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx/index' |
    '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx/index.md' |
    '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw' |
    '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw/index' |
    '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw/index.md' |
    '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r' |
    '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r/index' |
    '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r/index.md' |
    '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh' |
    '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh/index' |
    '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh/index.md' |
    '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9' |
    '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9/index' |
    '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9/index.md' |
    '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme' |
    '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme/index' |
    '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme/index.md' |
    '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla' |
    '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla/index' |
    '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla/index.md' |
    '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb' |
    '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb/index' |
    '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb/index.md' |
    '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm' |
    '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm/index' |
    '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm/index.md' |
    '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8' |
    '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8/index' |
    '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8/index.md' |
    '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y' |
    '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y/index' |
    '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y/index.md' |
    '/blog/custom-fraternity-pins-ngbm6hksaxfp' |
    '/blog/custom-fraternity-pins-ngbm6hksaxfp/index' |
    '/blog/custom-fraternity-pins-ngbm6hksaxfp/index.md' |
    '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw' |
    '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw/index' |
    '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw/index.md' |
    '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio' |
    '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio/index' |
    '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio/index.md' |
    '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh' |
    '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh/index' |
    '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh/index.md' |
    '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu' |
    '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu/index' |
    '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu/index.md' |
    '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf' |
    '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf/index' |
    '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf/index.md' |
    '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs' |
    '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs/index' |
    '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs/index.md' |
    '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67' |
    '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67/index' |
    '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67/index.md' |
    '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t' |
    '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t/index' |
    '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t/index.md' |
    '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98' |
    '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98/index' |
    '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98/index.md' |
    '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw' |
    '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw/index' |
    '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw/index.md' |
    '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c' |
    '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c/index' |
    '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c/index.md' |
    '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn' |
    '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn/index' |
    '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn/index.md' |
    '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az' |
    '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az/index' |
    '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az/index.md' |
    '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u' |
    '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u/index' |
    '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u/index.md' |
    '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute' |
    '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute/index' |
    '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute/index.md' |
    '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl' |
    '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl/index' |
    '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl/index.md' |
    '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57' |
    '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57/index' |
    '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57/index.md' |
    '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1' |
    '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1/index' |
    '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1/index.md' |
    '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf' |
    '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf/index' |
    '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf/index.md' |
    '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0' |
    '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0/index' |
    '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0/index.md' |
    '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim' |
    '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim/index' |
    '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim/index.md' |
    '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks' |
    '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks/index' |
    '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks/index.md' |
    '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se' |
    '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se/index' |
    '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se/index.md' |
    '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as' |
    '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as/index' |
    '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as/index.md' |
    '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5' |
    '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5/index' |
    '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5/index.md' |
    '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s' |
    '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s/index' |
    '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s/index.md' |
    '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx' |
    '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx/index' |
    '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx/index.md' |
    '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz' |
    '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz/index' |
    '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz/index.md' |
    '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef' |
    '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef/index' |
    '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef/index.md' |
    '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom' |
    '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom/index' |
    '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom/index.md' |
    '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci' |
    '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci/index' |
    '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci/index.md' |
    '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc' |
    '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc/index' |
    '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc/index.md' |
    '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag' |
    '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag/index' |
    '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag/index.md' |
    '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c' |
    '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c/index' |
    '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c/index.md' |
    '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45' |
    '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45/index' |
    '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45/index.md' |
    '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o' |
    '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o/index' |
    '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o/index.md' |
    '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7' |
    '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7/index' |
    '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7/index.md' |
    '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo' |
    '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo/index' |
    '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo/index.md' |
    '/blog/cutting-edge-coins-ng5ljvadlwqn' |
    '/blog/cutting-edge-coins-ng5ljvadlwqn/index' |
    '/blog/cutting-edge-coins-ng5ljvadlwqn/index.md' |
    '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw' |
    '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw/index' |
    '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw/index.md' |
    '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l' |
    '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l/index' |
    '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l/index.md' |
    '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q' |
    '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q/index' |
    '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q/index.md' |
    '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z' |
    '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z/index' |
    '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z/index.md' |
    '/blog/designing-custom-promotional-pins-ngbm1kkk89cz' |
    '/blog/designing-custom-promotional-pins-ngbm1kkk89cz/index' |
    '/blog/designing-custom-promotional-pins-ngbm1kkk89cz/index.md' |
    '/blog/designing-custom-trading-pins-ngbm1glw2cg4' |
    '/blog/designing-custom-trading-pins-ngbm1glw2cg4/index' |
    '/blog/designing-custom-trading-pins-ngbm1glw2cg4/index.md' |
    '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q' |
    '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q/index' |
    '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q/index.md' |
    '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg' |
    '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg/index' |
    '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg/index.md' |
    '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja' |
    '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja/index' |
    '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja/index.md' |
    '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff' |
    '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff/index' |
    '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff/index.md' |
    '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583' |
    '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583/index' |
    '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583/index.md' |
    '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2' |
    '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2/index' |
    '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2/index.md' |
    '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0' |
    '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0/index' |
    '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0/index.md' |
    '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs' |
    '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs/index' |
    '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs/index.md' |
    '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g' |
    '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g/index' |
    '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g/index.md' |
    '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp' |
    '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp/index' |
    '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp/index.md' |
    '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm' |
    '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm/index' |
    '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm/index.md' |
    '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv' |
    '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv/index' |
    '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv/index.md' |
    '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t' |
    '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t/index' |
    '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t/index.md' |
    '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc' |
    '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc/index' |
    '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc/index.md' |
    '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj' |
    '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj/index' |
    '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj/index.md' |
    '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi' |
    '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi/index' |
    '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi/index.md' |
    '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz' |
    '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz/index' |
    '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz/index.md' |
    '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3' |
    '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3/index' |
    '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3/index.md' |
    '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba' |
    '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba/index' |
    '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba/index.md' |
    '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd' |
    '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd/index' |
    '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd/index.md' |
    '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y' |
    '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y/index' |
    '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y/index.md' |
    '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5' |
    '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5/index' |
    '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5/index.md' |
    '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy' |
    '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy/index' |
    '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy/index.md' |
    '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4' |
    '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4/index' |
    '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4/index.md' |
    '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk' |
    '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk/index' |
    '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk/index.md' |
    '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj' |
    '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj/index' |
    '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj/index.md' |
    '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo' |
    '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo/index' |
    '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo/index.md' |
    '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x' |
    '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x/index' |
    '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x/index.md' |
    '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd' |
    '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd/index' |
    '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd/index.md' |
    '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5' |
    '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5/index' |
    '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5/index.md' |
    '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a' |
    '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a/index' |
    '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a/index.md' |
    '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4' |
    '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4/index' |
    '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4/index.md' |
    '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k' |
    '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k/index' |
    '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k/index.md' |
    '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y' |
    '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y/index' |
    '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y/index.md' |
    '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3' |
    '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3/index' |
    '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3/index.md' |
    '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2' |
    '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2/index' |
    '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2/index.md' |
    '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85' |
    '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85/index' |
    '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85/index.md' |
    '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r' |
    '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r/index' |
    '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r/index.md' |
    '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm' |
    '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm/index' |
    '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm/index.md' |
    '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7' |
    '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7/index' |
    '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7/index.md' |
    '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf' |
    '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf/index' |
    '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf/index.md' |
    '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6' |
    '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6/index' |
    '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6/index.md' |
    '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd' |
    '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd/index' |
    '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd/index.md' |
    '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw' |
    '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw/index' |
    '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw/index.md' |
    '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl' |
    '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl/index' |
    '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl/index.md' |
    '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4' |
    '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4/index' |
    '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4/index.md' |
    '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw' |
    '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw/index' |
    '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw/index.md' |
    '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys' |
    '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys/index' |
    '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys/index.md' |
    '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e' |
    '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e/index' |
    '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e/index.md' |
    '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz' |
    '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz/index' |
    '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz/index.md' |
    '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial' |
    '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial/index' |
    '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial/index.md' |
    '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4' |
    '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4/index' |
    '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4/index.md' |
    '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d' |
    '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d/index' |
    '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d/index.md' |
    '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn' |
    '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn/index' |
    '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn/index.md' |
    '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n' |
    '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n/index' |
    '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n/index.md' |
    '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9' |
    '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9/index' |
    '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9/index.md' |
    '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx' |
    '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx/index' |
    '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx/index.md' |
    '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d' |
    '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d/index' |
    '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d/index.md' |
    '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd' |
    '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd/index' |
    '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd/index.md' |
    '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9' |
    '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9/index' |
    '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9/index.md' |
    '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf' |
    '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf/index' |
    '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf/index.md' |
    '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g' |
    '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g/index' |
    '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g/index.md' |
    '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg' |
    '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg/index' |
    '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg/index.md' |
    '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn' |
    '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn/index' |
    '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn/index.md' |
    '/blog/masonic-challenge-coins-nh42qr2j6vfw' |
    '/blog/masonic-challenge-coins-nh42qr2j6vfw/index' |
    '/blog/masonic-challenge-coins-nh42qr2j6vfw/index.md' |
    '/blog/meme-enamel-pins-ngbm1ahco7dm' |
    '/blog/meme-enamel-pins-ngbm1ahco7dm/index' |
    '/blog/meme-enamel-pins-ngbm1ahco7dm/index.md' |
    '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j' |
    '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j/index' |
    '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j/index.md' |
    '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b' |
    '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b/index' |
    '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b/index.md' |
    '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395' |
    '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395/index' |
    '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395/index.md' |
    '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59' |
    '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59/index' |
    '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59/index.md' |
    '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq' |
    '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq/index' |
    '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq/index.md' |
    '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2' |
    '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2/index' |
    '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2/index.md' |
    '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f' |
    '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f/index' |
    '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f/index.md' |
    '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t' |
    '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t/index' |
    '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t/index.md' |
    '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx' |
    '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx/index' |
    '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx/index.md' |
    '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3' |
    '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3/index' |
    '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3/index.md' |
    '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o' |
    '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o/index' |
    '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o/index.md' |
    '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c' |
    '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c/index' |
    '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c/index.md' |
    '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x' |
    '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x/index' |
    '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x/index.md' |
    '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd' |
    '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd/index' |
    '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd/index.md' |
    '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz' |
    '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz/index' |
    '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz/index.md' |
    '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny' |
    '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny/index' |
    '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny/index.md' |
    '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49' |
    '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49/index' |
    '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49/index.md' |
    '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2' |
    '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2/index' |
    '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2/index.md' |
    '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll' |
    '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll/index' |
    '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll/index.md' |
    '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg' |
    '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg/index' |
    '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg/index.md' |
    '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1' |
    '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1/index' |
    '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1/index.md' |
    '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl' |
    '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl/index' |
    '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl/index.md' |
    '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu' |
    '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu/index' |
    '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu/index.md' |
    '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s' |
    '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s/index' |
    '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s/index.md' |
    '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj' |
    '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj/index' |
    '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj/index.md' |
    '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx' |
    '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx/index' |
    '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx/index.md' |
    '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6' |
    '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6/index' |
    '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6/index.md' |
    '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw' |
    '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw/index' |
    '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw/index.md' |
    '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic' |
    '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic/index' |
    '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic/index.md' |
    '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz' |
    '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz/index' |
    '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz/index.md' |
    '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66' |
    '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66/index' |
    '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66/index.md' |
    '/blog/pin-types-soft-enamel-ngbm2q29wlph' |
    '/blog/pin-types-soft-enamel-ngbm2q29wlph/index' |
    '/blog/pin-types-soft-enamel-ngbm2q29wlph/index.md' |
    '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx' |
    '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx/index' |
    '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx/index.md' |
    '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln' |
    '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln/index' |
    '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln/index.md' |
    '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07' |
    '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07/index' |
    '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07/index.md' |
    '/blog/political-party-pins-ngbm4r6vhw37' |
    '/blog/political-party-pins-ngbm4r6vhw37/index' |
    '/blog/political-party-pins-ngbm4r6vhw37/index.md' |
    '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7' |
    '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7/index' |
    '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7/index.md' |
    '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4' |
    '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4/index' |
    '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4/index.md' |
    '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag' |
    '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag/index' |
    '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag/index.md' |
    '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9' |
    '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9/index' |
    '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9/index.md' |
    '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj' |
    '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj/index' |
    '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj/index.md' |
    '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho' |
    '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho/index' |
    '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho/index.md' |
    '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh' |
    '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh/index' |
    '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh/index.md' |
    '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l' |
    '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l/index' |
    '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l/index.md' |
    '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9' |
    '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9/index' |
    '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9/index.md' |
    '/blog/quilters-custom-pins-ngbm6ps4psc9' |
    '/blog/quilters-custom-pins-ngbm6ps4psc9/index' |
    '/blog/quilters-custom-pins-ngbm6ps4psc9/index.md' |
    '/blog/radio-station-lapel-pins-ngbm4lltppa5' |
    '/blog/radio-station-lapel-pins-ngbm4lltppa5/index' |
    '/blog/radio-station-lapel-pins-ngbm4lltppa5/index.md' |
    '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i' |
    '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i/index' |
    '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i/index.md' |
    '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w' |
    '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w/index' |
    '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w/index.md' |
    '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3' |
    '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3/index' |
    '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3/index.md' |
    '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap' |
    '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap/index' |
    '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap/index.md' |
    '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi' |
    '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi/index' |
    '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi/index.md' |
    '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw' |
    '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw/index' |
    '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw/index.md' |
    '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3' |
    '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3/index' |
    '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3/index.md' |
    '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8' |
    '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8/index' |
    '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8/index.md' |
    '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3' |
    '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3/index' |
    '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3/index.md' |
    '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62' |
    '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62/index' |
    '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62/index.md' |
    '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y' |
    '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y/index' |
    '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y/index.md' |
    '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2' |
    '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2/index' |
    '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2/index.md' |
    '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9' |
    '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9/index' |
    '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9/index.md' |
    '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq' |
    '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq/index' |
    '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq/index.md' |
    '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs' |
    '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs/index' |
    '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs/index.md' |
    '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn' |
    '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn/index' |
    '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn/index.md' |
    '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y' |
    '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y/index' |
    '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y/index.md' |
    '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z' |
    '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z/index' |
    '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z/index.md' |
    '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n' |
    '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n/index' |
    '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n/index.md' |
    '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476' |
    '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476/index' |
    '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476/index.md' |
    '/blog/the-history-of-challenge-coins-ngbm35js8lz9' |
    '/blog/the-history-of-challenge-coins-ngbm35js8lz9/index' |
    '/blog/the-history-of-challenge-coins-ngbm35js8lz9/index.md' |
    '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd' |
    '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd/index' |
    '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd/index.md' |
    '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc' |
    '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc/index' |
    '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc/index.md' |
    '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86' |
    '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86/index' |
    '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86/index.md' |
    '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8' |
    '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8/index' |
    '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8/index.md' |
    '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr' |
    '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr/index' |
    '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr/index.md' |
    '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7' |
    '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7/index' |
    '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7/index.md' |
    '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7' |
    '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7/index' |
    '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7/index.md' |
    '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p' |
    '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p/index' |
    '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p/index.md' |
    '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj' |
    '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj/index' |
    '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj/index.md' |
    '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr' |
    '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr/index' |
    '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr/index.md' |
    '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah' |
    '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah/index' |
    '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah/index.md' |
    '/blog/trading-pin-faq-ngbm3ouo7sdl' |
    '/blog/trading-pin-faq-ngbm3ouo7sdl/index' |
    '/blog/trading-pin-faq-ngbm3ouo7sdl/index.md' |
    '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou' |
    '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou/index' |
    '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou/index.md' |
    '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r' |
    '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r/index' |
    '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r/index.md' |
    '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a' |
    '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a/index' |
    '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a/index.md' |
    '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg' |
    '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg/index' |
    '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg/index.md' |
    '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre' |
    '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre/index' |
    '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre/index.md' |
    '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31' |
    '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31/index' |
    '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31/index.md' |
    '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9' |
    '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9/index' |
    '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9/index.md' |
    '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv' |
    '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv/index' |
    '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv/index.md' |
    '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8' |
    '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8/index' |
    '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8/index.md' |
    '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30' |
    '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30/index' |
    '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30/index.md' |
    '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n' |
    '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n/index' |
    '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n/index.md' |
    '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd' |
    '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd/index' |
    '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd/index.md' |
    '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3' |
    '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3/index' |
    '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3/index.md' |
    '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3' |
    '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3/index' |
    '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3/index.md' |
    '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq' |
    '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq/index' |
    '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq/index.md' |
    '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e' |
    '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e/index' |
    '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e/index.md' |
    '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9' |
    '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9/index' |
    '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9/index.md' |
    '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod' |
    '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod/index' |
    '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod/index.md' |
    '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8' |
    '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8/index' |
    '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8/index.md' |
    '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3' |
    '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3/index' |
    '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3/index.md' |
    '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7' |
    '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7/index' |
    '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7/index.md' |
    '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o' |
    '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o/index' |
    '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o/index.md' |
    '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb' |
    '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb/index' |
    '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb/index.md' |
    '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l' |
    '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l/index' |
    '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l/index.md' |
    '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847' |
    '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847/index' |
    '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847/index.md' |
    '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u' |
    '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u/index' |
    '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u/index.md' |
    '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif' |
    '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif/index' |
    '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif/index.md' |
    '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6' |
    '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6/index' |
    '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6/index.md' |
    '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8' |
    '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8/index' |
    '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8/index.md' |
    '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz' |
    '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz/index' |
    '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz/index.md' |
    '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8' |
    '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8/index' |
    '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8/index.md' |
    '/blog/why-number-challenge-coins-ngbm46huiz8f' |
    '/blog/why-number-challenge-coins-ngbm46huiz8f/index' |
    '/blog/why-number-challenge-coins-ngbm46huiz8f/index.md' |
    '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0' |
    '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0/index' |
    '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0/index.md' |
    '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj' |
    '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj/index' |
    '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj/index.md' |
    '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh' |
    '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh/index' |
    '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh/index.md' |
    '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn' |
    '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn/index' |
    '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn/index.md' |
    '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf' |
    '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf/index' |
    '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf/index.md' |
    '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv' |
    '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv/index' |
    '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv/index.md' |
    '/bottle-openers' |
    '/bottle-openers/index' |
    '/bottle-openers/index.html' |
    '/cart' |
    '/cart.html' |
    '/challenge-coins' |
    '/challenge-coins/index' |
    '/challenge-coins/index.html' |
    '/change-password' |
    '/change-password.html' |
    '/checkout' |
    '/checkout.html' |
    '/cloisonne' |
    '/cloisonne/index' |
    '/cloisonne/index.md' |
    '/components' |
    '/components.html' |
    '/components/img-partial' |
    '/components/img-partial/index' |
    '/components/img-partial/index.md' |
    '/contact' |
    '/contact.html' |
    '/contact/success' |
    '/contact/success.html' |
    '/custom-pin-attachment-options' |
    '/custom-pin-attachment-options/index' |
    '/custom-pin-attachment-options/index.html' |
    '/custom-presentation-options' |
    '/custom-presentation-options/index' |
    '/custom-presentation-options/index.html' |
    '/customer-reviews' |
    '/customer-reviews.html' |
    '/dashboard' |
    '/dashboard.html' |
    '/diestruck' |
    '/diestruck/index' |
    '/diestruck/index.md' |
    '/dog-tags' |
    '/dog-tags/index' |
    '/dog-tags/index.html' |
    '/dye-sublimated' |
    '/dye-sublimated/index' |
    '/dye-sublimated/index.html' |
    '/employee-recognition-pins' |
    '/employee-recognition-pins/index' |
    '/employee-recognition-pins/index.html' |
    '/error' |
    '/error.html' |
    '/faq' |
    '/faq.md' |
    '/forgot' |
    '/forgot.html' |
    '/free-quote' |
    '/free-quote.html' |
    '/free-quote/details' |
    '/free-quote/details.html' |
    '/free-quote/in-depth' |
    '/free-quote/in-depth.html' |
    '/free-quote/review' |
    '/free-quote/review.html' |
    '/free-quote/thank-you' |
    '/free-quote/thank-you.html' |
    '/free-quote/upload' |
    '/free-quote/upload.html' |
    '/gallery' |
    '/gallery.html' |
    '/hat-pins' |
    '/hat-pins/index' |
    '/hat-pins/index.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/_index' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/_index.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/account-settings' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/account-settings.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/all-pricing' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/all-pricing.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog/_index' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog/_index.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/cart' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/cart.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/change-password' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/change-password.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/checkout' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/checkout.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial/index' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial/index.md' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact/success' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact/success.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/customer-reviews' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/customer-reviews.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/dashboard' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/dashboard.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/error' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/error.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/forgot' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/forgot.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/details' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/details.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/in-depth' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/in-depth.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/review' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/review.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/thank-you' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/thank-you.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/upload' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/upload.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/gallery' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/gallery.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/join' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/join.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login-email' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login-email.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/order-submitted' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/order-submitted.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders/track' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders/track.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/password-reset' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/password-reset.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-history' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-history.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-methods' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-methods.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/privacy' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/privacy.md' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quote' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quote.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quotes' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quotes.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revision-requests' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revision-requests.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revisions' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revisions.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/shipping-addresses' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/shipping-addresses.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tax-exemptions' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tax-exemptions.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/terms' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/terms.md' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tracking' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tracking.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/unsubscribed' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/unsubscribed.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/uploads' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/uploads.html' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index' |
    '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md' |
    '/join' |
    '/join.html' |
    '/keychains' |
    '/keychains/index' |
    '/keychains/index.html' |
    '/login' |
    '/login-email' |
    '/login-email.html' |
    '/login.html' |
    '/medallions' |
    '/medallions/index' |
    '/medallions/index.html' |
    '/nylon' |
    '/nylon/index' |
    '/nylon/index.html' |
    '/offset-printed' |
    '/offset-printed/index' |
    '/offset-printed/index.md' |
    '/order-submitted' |
    '/order-submitted.html' |
    '/orders' |
    '/orders.html' |
    '/orders/track' |
    '/orders/track.html' |
    '/password-reset' |
    '/password-reset.html' |
    '/payment-history' |
    '/payment-history.html' |
    '/payment-methods' |
    '/payment-methods.html' |
    '/polyester' |
    '/polyester/index' |
    '/polyester/index.html' |
    '/presentation-options' |
    '/presentation-options/index' |
    '/presentation-options/index.html' |
    '/pricing' |
    '/pricing/index' |
    '/pricing/index.html' |
    '/privacy' |
    '/privacy.md' |
    '/pvc' |
    '/pvc/index' |
    '/pvc/index.html' |
    '/quote' |
    '/quote.html' |
    '/quotes' |
    '/quotes.html' |
    '/revision-requests' |
    '/revision-requests.html' |
    '/revisions' |
    '/revisions.html' |
    '/rush-pin-quote-form' |
    '/rush-pin-quote-form/index' |
    '/rush-pin-quote-form/index.html' |
    '/shipping-addresses' |
    '/shipping-addresses.html' |
    '/silkscreen' |
    '/silkscreen/index' |
    '/silkscreen/index.md' |
    '/soft-enamel' |
    '/soft-enamel/index' |
    '/soft-enamel/index.md' |
    '/tax-exemptions' |
    '/tax-exemptions.html' |
    '/terms' |
    '/terms.md' |
    '/thank-you' |
    '/thank-you/index' |
    '/thank-you/index.html' |
    '/tracking' |
    '/tracking.html' |
    '/trading-pin-quote-form' |
    '/trading-pin-quote-form/index' |
    '/trading-pin-quote-form/index.html' |
    '/trading-pins' |
    '/trading-pins-delivery-options' |
    '/trading-pins-delivery-options/index' |
    '/trading-pins-delivery-options/index.html' |
    '/trading-pins/index' |
    '/trading-pins/index.md' |
    '/tube' |
    '/tube/index' |
    '/tube/index.html' |
    '/unsubscribed' |
    '/unsubscribed.html' |
    '/uploads' |
    '/uploads.html' |
    '/usa-rush-trading-pins' |
    '/usa-rush-trading-pins/index' |
    '/usa-rush-trading-pins/index.html' |
    '/uses/corporate-coins' |
    '/uses/corporate-coins/index' |
    '/uses/corporate-coins/index.html' |
    '/uses/ems-coins' |
    '/uses/ems-coins/index' |
    '/uses/ems-coins/index.html' |
    '/uses/entertainment-coins' |
    '/uses/entertainment-coins/index' |
    '/uses/entertainment-coins/index.html' |
    '/uses/firefighter-coins' |
    '/uses/firefighter-coins/index' |
    '/uses/firefighter-coins/index.html' |
    '/uses/freemason-coins' |
    '/uses/freemason-coins/index' |
    '/uses/freemason-coins/index.html' |
    '/uses/government-coins' |
    '/uses/government-coins/index' |
    '/uses/government-coins/index.html' |
    '/uses/international-coins' |
    '/uses/international-coins/index' |
    '/uses/international-coins/index.html' |
    '/uses/military-coins' |
    '/uses/military-coins/index' |
    '/uses/military-coins/index.html' |
    '/uses/police-coins' |
    '/uses/police-coins/index' |
    '/uses/police-coins/index.html' |
    '/uses/school-coins' |
    '/uses/school-coins/index' |
    '/uses/school-coins/index.html' |
    '/woven' |
    '/woven/index' |
    '/woven/index.html';

export function IsFile(path: string): path is File {
    return [
        '/',
        '/100',
        '/100/index',
        '/100/index.html',
        '/50',
        '/50/index',
        '/50/index.html',
        '/75',
        '/75/index',
        '/75/index.html',
        '/_index',
        '/_index.html',
        '/account-settings',
        '/account-settings.html',
        '/all-pricing',
        '/all-pricing.html',
        '/american-made-challenge-coins',
        '/american-made-challenge-coins/index',
        '/american-made-challenge-coins/index.html',
        '/american-made-free-quote',
        '/american-made-free-quote.html',
        '/american-made-free-quote/details',
        '/american-made-free-quote/details.html',
        '/american-made-free-quote/in-depth',
        '/american-made-free-quote/in-depth.html',
        '/american-made-free-quote/review',
        '/american-made-free-quote/review.html',
        '/american-made-free-quote/thank-you',
        '/american-made-free-quote/thank-you.html',
        '/american-made-free-quote/upload',
        '/american-made-free-quote/upload.html',
        '/american-made-rush-pins',
        '/american-made-rush-pins/index',
        '/american-made-rush-pins/index.html',
        '/attachments',
        '/attachments/index',
        '/attachments/index.html',
        '/blog',
        '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t',
        '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t/index',
        '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t/index.md',
        '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3',
        '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3/index',
        '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3/index.md',
        '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms',
        '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms/index',
        '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms/index.md',
        '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht',
        '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht/index',
        '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht/index.md',
        '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6',
        '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6/index',
        '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6/index.md',
        '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt',
        '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt/index',
        '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt/index.md',
        '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus',
        '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus/index',
        '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus/index.md',
        '/blog/_index',
        '/blog/_index.html',
        '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94',
        '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94/index',
        '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94/index.md',
        '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1',
        '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1/index',
        '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1/index.md',
        '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6',
        '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6/index',
        '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6/index.md',
        '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63',
        '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63/index',
        '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63/index.md',
        '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da',
        '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da/index',
        '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da/index.md',
        '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo',
        '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo/index',
        '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo/index.md',
        '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd',
        '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd/index',
        '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd/index.md',
        '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5',
        '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5/index',
        '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5/index.md',
        '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz',
        '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz/index',
        '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz/index.md',
        '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t',
        '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t/index',
        '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t/index.md',
        '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d',
        '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d/index',
        '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d/index.md',
        '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44',
        '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44/index',
        '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44/index.md',
        '/blog/baseball-pins-made-faster-ngbm3jrr160m',
        '/blog/baseball-pins-made-faster-ngbm3jrr160m/index',
        '/blog/baseball-pins-made-faster-ngbm3jrr160m/index.md',
        '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya',
        '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya/index',
        '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya/index.md',
        '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy',
        '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy/index',
        '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy/index.md',
        '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9',
        '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9/index',
        '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9/index.md',
        '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss',
        '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss/index',
        '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss/index.md',
        '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono',
        '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono/index',
        '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono/index.md',
        '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h',
        '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h/index',
        '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h/index.md',
        '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut',
        '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut/index',
        '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut/index.md',
        '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35',
        '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35/index',
        '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35/index.md',
        '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m',
        '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m/index',
        '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m/index.md',
        '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi',
        '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi/index',
        '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi/index.md',
        '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj',
        '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj/index',
        '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj/index.md',
        '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej',
        '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej/index',
        '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej/index.md',
        '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0',
        '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0/index',
        '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0/index.md',
        '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl',
        '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl/index',
        '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl/index.md',
        '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79',
        '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79/index',
        '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79/index.md',
        '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j',
        '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j/index',
        '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j/index.md',
        '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh',
        '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh/index',
        '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh/index.md',
        '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj',
        '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj/index',
        '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj/index.md',
        '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3',
        '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3/index',
        '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3/index.md',
        '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58',
        '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58/index',
        '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58/index.md',
        '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs',
        '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs/index',
        '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs/index.md',
        '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9',
        '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9/index',
        '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9/index.md',
        '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8',
        '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8/index',
        '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8/index.md',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9/index',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9/index.md',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26/index',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26/index.md',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j/index',
        '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j/index.md',
        '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7',
        '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7/index',
        '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7/index.md',
        '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag',
        '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag/index',
        '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag/index.md',
        '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk',
        '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk/index',
        '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk/index.md',
        '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa',
        '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa/index',
        '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa/index.md',
        '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk',
        '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk/index',
        '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk/index.md',
        '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx',
        '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx/index',
        '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx/index.md',
        '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i',
        '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i/index',
        '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i/index.md',
        '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i',
        '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i/index',
        '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i/index.md',
        '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe',
        '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe/index',
        '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe/index.md',
        '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41',
        '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41/index',
        '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41/index.md',
        '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj',
        '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj/index',
        '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj/index.md',
        '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx',
        '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx/index',
        '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx/index.md',
        '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr',
        '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr/index',
        '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr/index.md',
        '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde',
        '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde/index',
        '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde/index.md',
        '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr',
        '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr/index',
        '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr/index.md',
        '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h',
        '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h/index',
        '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h/index.md',
        '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac',
        '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac/index',
        '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac/index.md',
        '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt',
        '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt/index',
        '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt/index.md',
        '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5',
        '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5/index',
        '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5/index.md',
        '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx',
        '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx/index',
        '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx/index.md',
        '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2',
        '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2/index',
        '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2/index.md',
        '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy',
        '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy/index',
        '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy/index.md',
        '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c',
        '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c/index',
        '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c/index.md',
        '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei',
        '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei/index',
        '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei/index.md',
        '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18',
        '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18/index',
        '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18/index.md',
        '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm',
        '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm/index',
        '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm/index.md',
        '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32',
        '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32/index',
        '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32/index.md',
        '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo',
        '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo/index',
        '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo/index.md',
        '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68',
        '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68/index',
        '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68/index.md',
        '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99',
        '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99/index',
        '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99/index.md',
        '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02',
        '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02/index',
        '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02/index.md',
        '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek',
        '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek/index',
        '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek/index.md',
        '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt',
        '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt/index',
        '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt/index.md',
        '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5',
        '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5/index',
        '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5/index.md',
        '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc',
        '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc/index',
        '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc/index.md',
        '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l',
        '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l/index',
        '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l/index.md',
        '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0',
        '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0/index',
        '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0/index.md',
        '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884',
        '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884/index',
        '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884/index.md',
        '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o',
        '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o/index',
        '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o/index.md',
        '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1',
        '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1/index',
        '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1/index.md',
        '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh',
        '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh/index',
        '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh/index.md',
        '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki',
        '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki/index',
        '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki/index.md',
        '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e',
        '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e/index',
        '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e/index.md',
        '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py',
        '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py/index',
        '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py/index.md',
        '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in',
        '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in/index',
        '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in/index.md',
        '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6',
        '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6/index',
        '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6/index.md',
        '/blog/custom-attraction-lapel-pins-ngbm191bx0xc',
        '/blog/custom-attraction-lapel-pins-ngbm191bx0xc/index',
        '/blog/custom-attraction-lapel-pins-ngbm191bx0xc/index.md',
        '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv',
        '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv/index',
        '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv/index.md',
        '/blog/custom-challenge-coin-01-ngbm716lar18',
        '/blog/custom-challenge-coin-01-ngbm716lar18/index',
        '/blog/custom-challenge-coin-01-ngbm716lar18/index.md',
        '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi',
        '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi/index',
        '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi/index.md',
        '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl',
        '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl/index',
        '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl/index.md',
        '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr',
        '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr/index',
        '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr/index.md',
        '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b',
        '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b/index',
        '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b/index.md',
        '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6',
        '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6/index',
        '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6/index.md',
        '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u',
        '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u/index',
        '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u/index.md',
        '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33',
        '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33/index',
        '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33/index.md',
        '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni',
        '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni/index',
        '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni/index.md',
        '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas',
        '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas/index',
        '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas/index.md',
        '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq',
        '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq/index',
        '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq/index.md',
        '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk',
        '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk/index',
        '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk/index.md',
        '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86',
        '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86/index',
        '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86/index.md',
        '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd',
        '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd/index',
        '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd/index.md',
        '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe',
        '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe/index',
        '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe/index.md',
        '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w',
        '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w/index',
        '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w/index.md',
        '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc',
        '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc/index',
        '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc/index.md',
        '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z',
        '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z/index',
        '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z/index.md',
        '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50',
        '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50/index',
        '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50/index.md',
        '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat',
        '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat/index',
        '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat/index.md',
        '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo',
        '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo/index',
        '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo/index.md',
        '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4',
        '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4/index',
        '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4/index.md',
        '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv',
        '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv/index',
        '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv/index.md',
        '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b',
        '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b/index',
        '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b/index.md',
        '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu',
        '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu/index',
        '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu/index.md',
        '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh',
        '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh/index',
        '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh/index.md',
        '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf',
        '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf/index',
        '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf/index.md',
        '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo',
        '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo/index',
        '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo/index.md',
        '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu',
        '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu/index',
        '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu/index.md',
        '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq',
        '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq/index',
        '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq/index.md',
        '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib',
        '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib/index',
        '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib/index.md',
        '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx',
        '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx/index',
        '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx/index.md',
        '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw',
        '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw/index',
        '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw/index.md',
        '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r',
        '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r/index',
        '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r/index.md',
        '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh',
        '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh/index',
        '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh/index.md',
        '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9',
        '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9/index',
        '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9/index.md',
        '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme',
        '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme/index',
        '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme/index.md',
        '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla',
        '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla/index',
        '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla/index.md',
        '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb',
        '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb/index',
        '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb/index.md',
        '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm',
        '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm/index',
        '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm/index.md',
        '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8',
        '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8/index',
        '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8/index.md',
        '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y',
        '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y/index',
        '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y/index.md',
        '/blog/custom-fraternity-pins-ngbm6hksaxfp',
        '/blog/custom-fraternity-pins-ngbm6hksaxfp/index',
        '/blog/custom-fraternity-pins-ngbm6hksaxfp/index.md',
        '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw',
        '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw/index',
        '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw/index.md',
        '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio',
        '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio/index',
        '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio/index.md',
        '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh',
        '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh/index',
        '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh/index.md',
        '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu',
        '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu/index',
        '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu/index.md',
        '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf',
        '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf/index',
        '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf/index.md',
        '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs',
        '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs/index',
        '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs/index.md',
        '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67',
        '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67/index',
        '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67/index.md',
        '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t',
        '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t/index',
        '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t/index.md',
        '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98',
        '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98/index',
        '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98/index.md',
        '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw',
        '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw/index',
        '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw/index.md',
        '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c',
        '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c/index',
        '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c/index.md',
        '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn',
        '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn/index',
        '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn/index.md',
        '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az',
        '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az/index',
        '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az/index.md',
        '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u',
        '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u/index',
        '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u/index.md',
        '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute',
        '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute/index',
        '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute/index.md',
        '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl',
        '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl/index',
        '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl/index.md',
        '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57',
        '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57/index',
        '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57/index.md',
        '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1',
        '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1/index',
        '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1/index.md',
        '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf',
        '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf/index',
        '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf/index.md',
        '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0',
        '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0/index',
        '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0/index.md',
        '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim',
        '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim/index',
        '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim/index.md',
        '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks',
        '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks/index',
        '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks/index.md',
        '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se',
        '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se/index',
        '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se/index.md',
        '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as',
        '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as/index',
        '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as/index.md',
        '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5',
        '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5/index',
        '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5/index.md',
        '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s',
        '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s/index',
        '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s/index.md',
        '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx',
        '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx/index',
        '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx/index.md',
        '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz',
        '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz/index',
        '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz/index.md',
        '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef',
        '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef/index',
        '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef/index.md',
        '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom',
        '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom/index',
        '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom/index.md',
        '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci',
        '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci/index',
        '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci/index.md',
        '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc',
        '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc/index',
        '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc/index.md',
        '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag',
        '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag/index',
        '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag/index.md',
        '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c',
        '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c/index',
        '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c/index.md',
        '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45',
        '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45/index',
        '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45/index.md',
        '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o',
        '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o/index',
        '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o/index.md',
        '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7',
        '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7/index',
        '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7/index.md',
        '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo',
        '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo/index',
        '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo/index.md',
        '/blog/cutting-edge-coins-ng5ljvadlwqn',
        '/blog/cutting-edge-coins-ng5ljvadlwqn/index',
        '/blog/cutting-edge-coins-ng5ljvadlwqn/index.md',
        '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw',
        '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw/index',
        '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw/index.md',
        '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l',
        '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l/index',
        '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l/index.md',
        '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q',
        '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q/index',
        '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q/index.md',
        '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z',
        '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z/index',
        '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z/index.md',
        '/blog/designing-custom-promotional-pins-ngbm1kkk89cz',
        '/blog/designing-custom-promotional-pins-ngbm1kkk89cz/index',
        '/blog/designing-custom-promotional-pins-ngbm1kkk89cz/index.md',
        '/blog/designing-custom-trading-pins-ngbm1glw2cg4',
        '/blog/designing-custom-trading-pins-ngbm1glw2cg4/index',
        '/blog/designing-custom-trading-pins-ngbm1glw2cg4/index.md',
        '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q',
        '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q/index',
        '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q/index.md',
        '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg',
        '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg/index',
        '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg/index.md',
        '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja',
        '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja/index',
        '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja/index.md',
        '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff',
        '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff/index',
        '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff/index.md',
        '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583',
        '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583/index',
        '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583/index.md',
        '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2',
        '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2/index',
        '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2/index.md',
        '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0',
        '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0/index',
        '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0/index.md',
        '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs',
        '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs/index',
        '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs/index.md',
        '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g',
        '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g/index',
        '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g/index.md',
        '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp',
        '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp/index',
        '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp/index.md',
        '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm',
        '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm/index',
        '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm/index.md',
        '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv',
        '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv/index',
        '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv/index.md',
        '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t',
        '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t/index',
        '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t/index.md',
        '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc',
        '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc/index',
        '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc/index.md',
        '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj',
        '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj/index',
        '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj/index.md',
        '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi',
        '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi/index',
        '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi/index.md',
        '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz',
        '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz/index',
        '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz/index.md',
        '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3',
        '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3/index',
        '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3/index.md',
        '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba',
        '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba/index',
        '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba/index.md',
        '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd',
        '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd/index',
        '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd/index.md',
        '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y',
        '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y/index',
        '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y/index.md',
        '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5',
        '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5/index',
        '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5/index.md',
        '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy',
        '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy/index',
        '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy/index.md',
        '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4',
        '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4/index',
        '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4/index.md',
        '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk',
        '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk/index',
        '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk/index.md',
        '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj',
        '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj/index',
        '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj/index.md',
        '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo',
        '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo/index',
        '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo/index.md',
        '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x',
        '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x/index',
        '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x/index.md',
        '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd',
        '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd/index',
        '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd/index.md',
        '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5',
        '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5/index',
        '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5/index.md',
        '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a',
        '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a/index',
        '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a/index.md',
        '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4',
        '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4/index',
        '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4/index.md',
        '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k',
        '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k/index',
        '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k/index.md',
        '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y',
        '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y/index',
        '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y/index.md',
        '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3',
        '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3/index',
        '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3/index.md',
        '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2',
        '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2/index',
        '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2/index.md',
        '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85',
        '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85/index',
        '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85/index.md',
        '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r',
        '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r/index',
        '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r/index.md',
        '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm',
        '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm/index',
        '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm/index.md',
        '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7',
        '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7/index',
        '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7/index.md',
        '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf',
        '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf/index',
        '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf/index.md',
        '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6',
        '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6/index',
        '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6/index.md',
        '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd',
        '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd/index',
        '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd/index.md',
        '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw',
        '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw/index',
        '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw/index.md',
        '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl',
        '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl/index',
        '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl/index.md',
        '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4',
        '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4/index',
        '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4/index.md',
        '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw',
        '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw/index',
        '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw/index.md',
        '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys',
        '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys/index',
        '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys/index.md',
        '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e',
        '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e/index',
        '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e/index.md',
        '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz',
        '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz/index',
        '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz/index.md',
        '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial',
        '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial/index',
        '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial/index.md',
        '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4',
        '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4/index',
        '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4/index.md',
        '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d',
        '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d/index',
        '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d/index.md',
        '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn',
        '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn/index',
        '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn/index.md',
        '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n',
        '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n/index',
        '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n/index.md',
        '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9',
        '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9/index',
        '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9/index.md',
        '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx',
        '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx/index',
        '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx/index.md',
        '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d',
        '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d/index',
        '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d/index.md',
        '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd',
        '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd/index',
        '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd/index.md',
        '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9',
        '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9/index',
        '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9/index.md',
        '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf',
        '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf/index',
        '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf/index.md',
        '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g',
        '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g/index',
        '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g/index.md',
        '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg',
        '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg/index',
        '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg/index.md',
        '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn',
        '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn/index',
        '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn/index.md',
        '/blog/masonic-challenge-coins-nh42qr2j6vfw',
        '/blog/masonic-challenge-coins-nh42qr2j6vfw/index',
        '/blog/masonic-challenge-coins-nh42qr2j6vfw/index.md',
        '/blog/meme-enamel-pins-ngbm1ahco7dm',
        '/blog/meme-enamel-pins-ngbm1ahco7dm/index',
        '/blog/meme-enamel-pins-ngbm1ahco7dm/index.md',
        '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j',
        '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j/index',
        '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j/index.md',
        '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b',
        '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b/index',
        '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b/index.md',
        '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395',
        '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395/index',
        '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395/index.md',
        '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59',
        '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59/index',
        '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59/index.md',
        '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq',
        '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq/index',
        '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq/index.md',
        '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2',
        '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2/index',
        '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2/index.md',
        '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f',
        '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f/index',
        '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f/index.md',
        '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t',
        '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t/index',
        '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t/index.md',
        '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx',
        '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx/index',
        '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx/index.md',
        '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3',
        '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3/index',
        '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3/index.md',
        '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o',
        '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o/index',
        '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o/index.md',
        '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c',
        '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c/index',
        '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c/index.md',
        '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x',
        '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x/index',
        '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x/index.md',
        '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd',
        '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd/index',
        '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd/index.md',
        '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz',
        '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz/index',
        '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz/index.md',
        '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny',
        '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny/index',
        '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny/index.md',
        '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49',
        '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49/index',
        '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49/index.md',
        '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2',
        '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2/index',
        '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2/index.md',
        '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll',
        '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll/index',
        '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll/index.md',
        '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg',
        '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg/index',
        '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg/index.md',
        '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1',
        '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1/index',
        '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1/index.md',
        '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl',
        '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl/index',
        '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl/index.md',
        '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu',
        '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu/index',
        '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu/index.md',
        '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s',
        '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s/index',
        '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s/index.md',
        '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj',
        '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj/index',
        '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj/index.md',
        '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx',
        '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx/index',
        '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx/index.md',
        '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6',
        '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6/index',
        '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6/index.md',
        '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw',
        '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw/index',
        '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw/index.md',
        '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic',
        '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic/index',
        '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic/index.md',
        '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz',
        '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz/index',
        '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz/index.md',
        '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66',
        '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66/index',
        '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66/index.md',
        '/blog/pin-types-soft-enamel-ngbm2q29wlph',
        '/blog/pin-types-soft-enamel-ngbm2q29wlph/index',
        '/blog/pin-types-soft-enamel-ngbm2q29wlph/index.md',
        '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx',
        '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx/index',
        '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx/index.md',
        '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln',
        '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln/index',
        '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln/index.md',
        '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07',
        '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07/index',
        '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07/index.md',
        '/blog/political-party-pins-ngbm4r6vhw37',
        '/blog/political-party-pins-ngbm4r6vhw37/index',
        '/blog/political-party-pins-ngbm4r6vhw37/index.md',
        '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7',
        '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7/index',
        '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7/index.md',
        '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4',
        '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4/index',
        '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4/index.md',
        '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag',
        '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag/index',
        '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag/index.md',
        '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9',
        '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9/index',
        '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9/index.md',
        '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj',
        '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj/index',
        '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj/index.md',
        '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho',
        '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho/index',
        '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho/index.md',
        '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh',
        '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh/index',
        '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh/index.md',
        '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l',
        '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l/index',
        '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l/index.md',
        '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9',
        '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9/index',
        '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9/index.md',
        '/blog/quilters-custom-pins-ngbm6ps4psc9',
        '/blog/quilters-custom-pins-ngbm6ps4psc9/index',
        '/blog/quilters-custom-pins-ngbm6ps4psc9/index.md',
        '/blog/radio-station-lapel-pins-ngbm4lltppa5',
        '/blog/radio-station-lapel-pins-ngbm4lltppa5/index',
        '/blog/radio-station-lapel-pins-ngbm4lltppa5/index.md',
        '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i',
        '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i/index',
        '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i/index.md',
        '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w',
        '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w/index',
        '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w/index.md',
        '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3',
        '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3/index',
        '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3/index.md',
        '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap',
        '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap/index',
        '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap/index.md',
        '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi',
        '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi/index',
        '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi/index.md',
        '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw',
        '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw/index',
        '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw/index.md',
        '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3',
        '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3/index',
        '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3/index.md',
        '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8',
        '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8/index',
        '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8/index.md',
        '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3',
        '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3/index',
        '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3/index.md',
        '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62',
        '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62/index',
        '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62/index.md',
        '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y',
        '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y/index',
        '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y/index.md',
        '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2',
        '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2/index',
        '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2/index.md',
        '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9',
        '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9/index',
        '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9/index.md',
        '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq',
        '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq/index',
        '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq/index.md',
        '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs',
        '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs/index',
        '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs/index.md',
        '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn',
        '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn/index',
        '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn/index.md',
        '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y',
        '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y/index',
        '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y/index.md',
        '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z',
        '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z/index',
        '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z/index.md',
        '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n',
        '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n/index',
        '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n/index.md',
        '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476',
        '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476/index',
        '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476/index.md',
        '/blog/the-history-of-challenge-coins-ngbm35js8lz9',
        '/blog/the-history-of-challenge-coins-ngbm35js8lz9/index',
        '/blog/the-history-of-challenge-coins-ngbm35js8lz9/index.md',
        '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd',
        '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd/index',
        '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd/index.md',
        '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc',
        '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc/index',
        '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc/index.md',
        '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86',
        '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86/index',
        '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86/index.md',
        '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8',
        '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8/index',
        '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8/index.md',
        '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr',
        '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr/index',
        '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr/index.md',
        '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7',
        '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7/index',
        '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7/index.md',
        '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7',
        '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7/index',
        '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7/index.md',
        '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p',
        '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p/index',
        '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p/index.md',
        '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj',
        '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj/index',
        '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj/index.md',
        '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr',
        '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr/index',
        '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr/index.md',
        '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah',
        '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah/index',
        '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah/index.md',
        '/blog/trading-pin-faq-ngbm3ouo7sdl',
        '/blog/trading-pin-faq-ngbm3ouo7sdl/index',
        '/blog/trading-pin-faq-ngbm3ouo7sdl/index.md',
        '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou',
        '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou/index',
        '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou/index.md',
        '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r',
        '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r/index',
        '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r/index.md',
        '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a',
        '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a/index',
        '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a/index.md',
        '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg',
        '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg/index',
        '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg/index.md',
        '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre',
        '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre/index',
        '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre/index.md',
        '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31',
        '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31/index',
        '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31/index.md',
        '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9',
        '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9/index',
        '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9/index.md',
        '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv',
        '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv/index',
        '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv/index.md',
        '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8',
        '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8/index',
        '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8/index.md',
        '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30',
        '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30/index',
        '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30/index.md',
        '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n',
        '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n/index',
        '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n/index.md',
        '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd',
        '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd/index',
        '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd/index.md',
        '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3',
        '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3/index',
        '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3/index.md',
        '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3',
        '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3/index',
        '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3/index.md',
        '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq',
        '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq/index',
        '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq/index.md',
        '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e',
        '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e/index',
        '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e/index.md',
        '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9',
        '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9/index',
        '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9/index.md',
        '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod',
        '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod/index',
        '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod/index.md',
        '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8',
        '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8/index',
        '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8/index.md',
        '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3',
        '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3/index',
        '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3/index.md',
        '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7',
        '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7/index',
        '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7/index.md',
        '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o',
        '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o/index',
        '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o/index.md',
        '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb',
        '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb/index',
        '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb/index.md',
        '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l',
        '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l/index',
        '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l/index.md',
        '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847',
        '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847/index',
        '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847/index.md',
        '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u',
        '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u/index',
        '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u/index.md',
        '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif',
        '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif/index',
        '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif/index.md',
        '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6',
        '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6/index',
        '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6/index.md',
        '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8',
        '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8/index',
        '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8/index.md',
        '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz',
        '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz/index',
        '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz/index.md',
        '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8',
        '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8/index',
        '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8/index.md',
        '/blog/why-number-challenge-coins-ngbm46huiz8f',
        '/blog/why-number-challenge-coins-ngbm46huiz8f/index',
        '/blog/why-number-challenge-coins-ngbm46huiz8f/index.md',
        '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0',
        '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0/index',
        '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0/index.md',
        '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj',
        '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj/index',
        '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj/index.md',
        '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh',
        '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh/index',
        '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh/index.md',
        '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn',
        '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn/index',
        '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn/index.md',
        '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf',
        '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf/index',
        '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf/index.md',
        '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv',
        '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv/index',
        '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv/index.md',
        '/bottle-openers',
        '/bottle-openers/index',
        '/bottle-openers/index.html',
        '/cart',
        '/cart.html',
        '/challenge-coins',
        '/challenge-coins/index',
        '/challenge-coins/index.html',
        '/change-password',
        '/change-password.html',
        '/checkout',
        '/checkout.html',
        '/cloisonne',
        '/cloisonne/index',
        '/cloisonne/index.md',
        '/components',
        '/components.html',
        '/components/img-partial',
        '/components/img-partial/index',
        '/components/img-partial/index.md',
        '/contact',
        '/contact.html',
        '/contact/success',
        '/contact/success.html',
        '/custom-pin-attachment-options',
        '/custom-pin-attachment-options/index',
        '/custom-pin-attachment-options/index.html',
        '/custom-presentation-options',
        '/custom-presentation-options/index',
        '/custom-presentation-options/index.html',
        '/customer-reviews',
        '/customer-reviews.html',
        '/dashboard',
        '/dashboard.html',
        '/diestruck',
        '/diestruck/index',
        '/diestruck/index.md',
        '/dog-tags',
        '/dog-tags/index',
        '/dog-tags/index.html',
        '/dye-sublimated',
        '/dye-sublimated/index',
        '/dye-sublimated/index.html',
        '/employee-recognition-pins',
        '/employee-recognition-pins/index',
        '/employee-recognition-pins/index.html',
        '/error',
        '/error.html',
        '/faq',
        '/faq.md',
        '/forgot',
        '/forgot.html',
        '/free-quote',
        '/free-quote.html',
        '/free-quote/details',
        '/free-quote/details.html',
        '/free-quote/in-depth',
        '/free-quote/in-depth.html',
        '/free-quote/review',
        '/free-quote/review.html',
        '/free-quote/thank-you',
        '/free-quote/thank-you.html',
        '/free-quote/upload',
        '/free-quote/upload.html',
        '/gallery',
        '/gallery.html',
        '/hat-pins',
        '/hat-pins/index',
        '/hat-pins/index.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/_index',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/_index.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/account-settings',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/account-settings.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/all-pricing',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/all-pricing.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog/_index',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog/_index.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/cart',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/cart.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/change-password',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/change-password.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/checkout',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/checkout.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial/index',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial/index.md',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact/success',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact/success.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/customer-reviews',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/customer-reviews.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/dashboard',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/dashboard.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/error',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/error.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/forgot',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/forgot.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/details',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/details.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/in-depth',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/in-depth.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/review',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/review.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/thank-you',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/thank-you.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/upload',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/upload.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/gallery',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/gallery.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/join',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/join.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login-email',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login-email.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/order-submitted',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/order-submitted.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders/track',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders/track.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/password-reset',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/password-reset.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-history',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-history.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-methods',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-methods.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/privacy',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/privacy.md',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quote',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quote.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quotes',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quotes.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revision-requests',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revision-requests.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revisions',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revisions.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/shipping-addresses',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/shipping-addresses.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tax-exemptions',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tax-exemptions.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/terms',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/terms.md',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tracking',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tracking.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/unsubscribed',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/unsubscribed.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/uploads',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/uploads.html',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index',
        '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md',
        '/join',
        '/join.html',
        '/keychains',
        '/keychains/index',
        '/keychains/index.html',
        '/login',
        '/login-email',
        '/login-email.html',
        '/login.html',
        '/medallions',
        '/medallions/index',
        '/medallions/index.html',
        '/nylon',
        '/nylon/index',
        '/nylon/index.html',
        '/offset-printed',
        '/offset-printed/index',
        '/offset-printed/index.md',
        '/order-submitted',
        '/order-submitted.html',
        '/orders',
        '/orders.html',
        '/orders/track',
        '/orders/track.html',
        '/password-reset',
        '/password-reset.html',
        '/payment-history',
        '/payment-history.html',
        '/payment-methods',
        '/payment-methods.html',
        '/polyester',
        '/polyester/index',
        '/polyester/index.html',
        '/presentation-options',
        '/presentation-options/index',
        '/presentation-options/index.html',
        '/pricing',
        '/pricing/index',
        '/pricing/index.html',
        '/privacy',
        '/privacy.md',
        '/pvc',
        '/pvc/index',
        '/pvc/index.html',
        '/quote',
        '/quote.html',
        '/quotes',
        '/quotes.html',
        '/revision-requests',
        '/revision-requests.html',
        '/revisions',
        '/revisions.html',
        '/rush-pin-quote-form',
        '/rush-pin-quote-form/index',
        '/rush-pin-quote-form/index.html',
        '/shipping-addresses',
        '/shipping-addresses.html',
        '/silkscreen',
        '/silkscreen/index',
        '/silkscreen/index.md',
        '/soft-enamel',
        '/soft-enamel/index',
        '/soft-enamel/index.md',
        '/tax-exemptions',
        '/tax-exemptions.html',
        '/terms',
        '/terms.md',
        '/thank-you',
        '/thank-you/index',
        '/thank-you/index.html',
        '/tracking',
        '/tracking.html',
        '/trading-pin-quote-form',
        '/trading-pin-quote-form/index',
        '/trading-pin-quote-form/index.html',
        '/trading-pins',
        '/trading-pins-delivery-options',
        '/trading-pins-delivery-options/index',
        '/trading-pins-delivery-options/index.html',
        '/trading-pins/index',
        '/trading-pins/index.md',
        '/tube',
        '/tube/index',
        '/tube/index.html',
        '/unsubscribed',
        '/unsubscribed.html',
        '/uploads',
        '/uploads.html',
        '/usa-rush-trading-pins',
        '/usa-rush-trading-pins/index',
        '/usa-rush-trading-pins/index.html',
        '/uses/corporate-coins',
        '/uses/corporate-coins/index',
        '/uses/corporate-coins/index.html',
        '/uses/ems-coins',
        '/uses/ems-coins/index',
        '/uses/ems-coins/index.html',
        '/uses/entertainment-coins',
        '/uses/entertainment-coins/index',
        '/uses/entertainment-coins/index.html',
        '/uses/firefighter-coins',
        '/uses/firefighter-coins/index',
        '/uses/firefighter-coins/index.html',
        '/uses/freemason-coins',
        '/uses/freemason-coins/index',
        '/uses/freemason-coins/index.html',
        '/uses/government-coins',
        '/uses/government-coins/index',
        '/uses/government-coins/index.html',
        '/uses/international-coins',
        '/uses/international-coins/index',
        '/uses/international-coins/index.html',
        '/uses/military-coins',
        '/uses/military-coins/index',
        '/uses/military-coins/index.html',
        '/uses/police-coins',
        '/uses/police-coins/index',
        '/uses/police-coins/index.html',
        '/uses/school-coins',
        '/uses/school-coins/index',
        '/uses/school-coins/index.html',
        '/woven',
        '/woven/index',
        '/woven/index.html',
    ].includes(path);
}

export function Relref(path: File): string {
    switch (path) {
    case '/':
        return '/';
    case '/100':
        return '/100/';
    case '/100/index':
        return '/100/';
    case '/100/index.html':
        return '/100/';
    case '/50':
        return '/50/';
    case '/50/index':
        return '/50/';
    case '/50/index.html':
        return '/50/';
    case '/75':
        return '/75/';
    case '/75/index':
        return '/75/';
    case '/75/index.html':
        return '/75/';
    case '/_index':
        return '/';
    case '/_index.html':
        return '/';
    case '/account-settings':
        return '/account-settings/';
    case '/account-settings.html':
        return '/account-settings/';
    case '/all-pricing':
        return '/all-pricing/';
    case '/all-pricing.html':
        return '/all-pricing/';
    case '/american-made-challenge-coins':
        return '/american-made-challenge-coins/';
    case '/american-made-challenge-coins/index':
        return '/american-made-challenge-coins/';
    case '/american-made-challenge-coins/index.html':
        return '/american-made-challenge-coins/';
    case '/american-made-free-quote':
        return '/american-made-free-quote/';
    case '/american-made-free-quote.html':
        return '/american-made-free-quote/';
    case '/american-made-free-quote/details':
        return '/american-made-free-quote/details/';
    case '/american-made-free-quote/details.html':
        return '/american-made-free-quote/details/';
    case '/american-made-free-quote/in-depth':
        return '/american-made-free-quote/in-depth/';
    case '/american-made-free-quote/in-depth.html':
        return '/american-made-free-quote/in-depth/';
    case '/american-made-free-quote/review':
        return '/american-made-free-quote/review/';
    case '/american-made-free-quote/review.html':
        return '/american-made-free-quote/review/';
    case '/american-made-free-quote/thank-you':
        return '/american-made-free-quote/thank-you/';
    case '/american-made-free-quote/thank-you.html':
        return '/american-made-free-quote/thank-you/';
    case '/american-made-free-quote/upload':
        return '/american-made-free-quote/upload/';
    case '/american-made-free-quote/upload.html':
        return '/american-made-free-quote/upload/';
    case '/american-made-rush-pins':
        return '/american-made-rush-pins/';
    case '/american-made-rush-pins/index':
        return '/american-made-rush-pins/';
    case '/american-made-rush-pins/index.html':
        return '/american-made-rush-pins/';
    case '/attachments':
        return '/attachments/';
    case '/attachments/index':
        return '/attachments/';
    case '/attachments/index.html':
        return '/attachments/';
    case '/blog':
        return '/blog/';
    case '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t':
        return '/blog/3d-coins-with-color-get-to-know-the-uv-print-process/';
    case '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t/index':
        return '/blog/3d-coins-with-color-get-to-know-the-uv-print-process/';
    case '/blog/3d-coins-with-color-get-to-know-the-uv-print-process-ngbm8vdyu25t/index.md':
        return '/blog/3d-coins-with-color-get-to-know-the-uv-print-process/';
    case '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3':
        return '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects/';
    case '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3/index':
        return '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects/';
    case '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects-ngbm2v2nw0g3/index.md':
        return '/blog/3d-sculpted-lapel-pins-make-it-easy-to-duplicate-real-objects/';
    case '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms':
        return '/blog/5-questions-to-ask-before-ordering-custom-pins/';
    case '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms/index':
        return '/blog/5-questions-to-ask-before-ordering-custom-pins/';
    case '/blog/5-questions-to-ask-before-ordering-custom-pins-ngbm1n5ex8ms/index.md':
        return '/blog/5-questions-to-ask-before-ordering-custom-pins/';
    case '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht':
        return '/blog/5-tips-for-packaging-custom-pins/';
    case '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht/index':
        return '/blog/5-tips-for-packaging-custom-pins/';
    case '/blog/5-tips-for-packaging-custom-pins-ngbm1yt6o7ht/index.md':
        return '/blog/5-tips-for-packaging-custom-pins/';
    case '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6':
        return '/blog/5-ways-to-make-custom-lapel-pins-pop/';
    case '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6/index':
        return '/blog/5-ways-to-make-custom-lapel-pins-pop/';
    case '/blog/5-ways-to-make-custom-lapel-pins-pop-ngbm1u69d1n6/index.md':
        return '/blog/5-ways-to-make-custom-lapel-pins-pop/';
    case '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt':
        return '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins/';
    case '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt/index':
        return '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins/';
    case '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins-ngbm1i6f43dt/index.md':
        return '/blog/6-money-saving-tips-for-ordering-custom-baseball-trading-pins/';
    case '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus':
        return '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care/';
    case '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus/index':
        return '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care/';
    case '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care-ngbm8kszoyus/index.md':
        return '/blog/7-first-responders-awarded-challenge-coins-by-the-musc-for-exceptional-pediatric-care/';
    case '/blog/_index':
        return '/blog/';
    case '/blog/_index.html':
        return '/blog/';
    case '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94':
        return '/blog/a-guide-to-understanding-your-digital-proof/';
    case '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94/index':
        return '/blog/a-guide-to-understanding-your-digital-proof/';
    case '/blog/a-guide-to-understanding-your-digital-proof-ngbm3imrqm94/index.md':
        return '/blog/a-guide-to-understanding-your-digital-proof/';
    case '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1':
        return '/blog/a-judges-verdict-challenge-coins/';
    case '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1/index':
        return '/blog/a-judges-verdict-challenge-coins/';
    case '/blog/a-judges-verdict-challenge-coins-ngbm64k477t1/index.md':
        return '/blog/a-judges-verdict-challenge-coins/';
    case '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6':
        return '/blog/a-legacy-of-calling-university-challenge-coins/';
    case '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6/index':
        return '/blog/a-legacy-of-calling-university-challenge-coins/';
    case '/blog/a-legacy-of-calling-university-challenge-coins-ngbm7k1ar1b6/index.md':
        return '/blog/a-legacy-of-calling-university-challenge-coins/';
    case '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63':
        return '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins/';
    case '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63/index':
        return '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins/';
    case '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins-ngbm1wj27l63/index.md':
        return '/blog/advertise-your-skateboard-shop-through-your-very-own-custom-lapel-pins/';
    case '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da':
        return '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home/';
    case '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da/index':
        return '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home/';
    case '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home-ngw0lcrmk5da/index.md':
        return '/blog/alaskas-best-fishing-and-the-keepsakes-you-bring-home/';
    case '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo':
        return '/blog/all-about-coins-offers-new-lower-minimum-order/';
    case '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo/index':
        return '/blog/all-about-coins-offers-new-lower-minimum-order/';
    case '/blog/all-about-coins-offers-new-lower-minimum-order-ngbm4ow1ygxo/index.md':
        return '/blog/all-about-coins-offers-new-lower-minimum-order/';
    case '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd':
        return '/blog/all-about-pins-holiday-schedule/';
    case '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd/index':
        return '/blog/all-about-pins-holiday-schedule/';
    case '/blog/all-about-pins-holiday-schedule-ngbm4hxkwdtd/index.md':
        return '/blog/all-about-pins-holiday-schedule/';
    case '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5':
        return '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event/';
    case '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5/index':
        return '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event/';
    case '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event-ngbm2selt8i5/index.md':
        return '/blog/american-airlines-and-susan-g-komen-come-together-for-special-golfing-event/';
    case '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz':
        return '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year/';
    case '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz/index':
        return '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year/';
    case '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year-ngbm1o2a5bqz/index.md':
        return '/blog/announce-your-schools-breakfast-program-in-a-memorable-way-this-year/';
    case '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t':
        return '/blog/appalachian-state-university-creates-senior-class-gift/';
    case '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t/index':
        return '/blog/appalachian-state-university-creates-senior-class-gift/';
    case '/blog/appalachian-state-university-creates-senior-class-gift-ngbm4fdl3k8t/index.md':
        return '/blog/appalachian-state-university-creates-senior-class-gift/';
    case '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d':
        return '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend/';
    case '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d/index':
        return '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend/';
    case '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend-ngbm137h818d/index.md':
        return '/blog/army-community-service-survivor-outreach-services-creates-custom-lapel-pins-for-victory-junction-families-of-fallen-heroes-weekend/';
    case '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44':
        return '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans/';
    case '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44/index':
        return '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans/';
    case '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans-ngbm2ivf7q44/index.md':
        return '/blog/bands-and-musicians-create-custom-lapel-pins-for-fans/';
    case '/blog/baseball-pins-made-faster-ngbm3jrr160m':
        return '/blog/baseball-pins-made-faster/';
    case '/blog/baseball-pins-made-faster-ngbm3jrr160m/index':
        return '/blog/baseball-pins-made-faster/';
    case '/blog/baseball-pins-made-faster-ngbm3jrr160m/index.md':
        return '/blog/baseball-pins-made-faster/';
    case '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya':
        return '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today/';
    case '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya/index':
        return '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today/';
    case '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today-ngbm2h0ppdya/index.md':
        return '/blog/baseball-season-is-fast-approaching-get-your-trading-pin-order-in-today/';
    case '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy':
        return '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins/';
    case '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy/index':
        return '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins/';
    case '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins-ngbm6aop6rqy/index.md':
        return '/blog/behind-the-print-a-deep-dive-into-uv-printed-pins/';
    case '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9':
        return '/blog/blackberry-smoke-and-the-smokers-lounge/';
    case '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9/index':
        return '/blog/blackberry-smoke-and-the-smokers-lounge/';
    case '/blog/blackberry-smoke-and-the-smokers-lounge-njsukf3wi7b9/index.md':
        return '/blog/blackberry-smoke-and-the-smokers-lounge/';
    case '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss':
        return '/blog/boost-morale-with-employee-recognition-coins/';
    case '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss/index':
        return '/blog/boost-morale-with-employee-recognition-coins/';
    case '/blog/boost-morale-with-employee-recognition-coins-nig1y16a8kss/index.md':
        return '/blog/boost-morale-with-employee-recognition-coins/';
    case '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono':
        return '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin/';
    case '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono/index':
        return '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin/';
    case '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin-ngbm5di2nono/index.md':
        return '/blog/bp-shows-their-commitment-to-clean-up-with-wildlife-logo-lapel-pin/';
    case '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h':
        return '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season/';
    case '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h/index':
        return '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season/';
    case '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season-ngbm3tktv96h/index.md':
        return '/blog/byu-baseball-creates-custom-challenge-coin-for-2012-season/';
    case '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut':
        return '/blog/can-my-custom-products-be-shipped-to-an-international-address/';
    case '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut/index':
        return '/blog/can-my-custom-products-be-shipped-to-an-international-address/';
    case '/blog/can-my-custom-products-be-shipped-to-an-international-address-ngbm4nuc7gut/index.md':
        return '/blog/can-my-custom-products-be-shipped-to-an-international-address/';
    case '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35':
        return '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model/';
    case '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35/index':
        return '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model/';
    case '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model-ngbm3mg7mf35/index.md':
        return '/blog/carlsen-volvo-sees-great-versatility-and-potential-in-custom-lapel-pins-in-their-business-model/';
    case '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m':
        return '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins/';
    case '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m/index':
        return '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins/';
    case '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins-ngbm51xfeg8m/index.md':
        return '/blog/celebrate-chattanooga-oktoberfest-with-custom-pins/';
    case '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi':
        return '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins/';
    case '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi/index':
        return '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins/';
    case '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins-ngbm2nat3exi/index.md':
        return '/blog/celebrate-satchmo-days-with-custom-jazz-lapel-pins/';
    case '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj':
        return '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins/';
    case '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj/index':
        return '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins/';
    case '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins-ngbm4ulp5ljj/index.md':
        return '/blog/celebrate-your-sea-kayak-trip-with-custom-lapel-pins/';
    case '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej':
        return '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins/';
    case '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej/index':
        return '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins/';
    case '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins-ngbm4accoaej/index.md':
        return '/blog/celebrate-your-unique-state-through-the-creation-of-custom-lapel-pins/';
    case '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0':
        return '/blog/celebrating-police-appreciation-week-with-custom-coins/';
    case '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0/index':
        return '/blog/celebrating-police-appreciation-week-with-custom-coins/';
    case '/blog/celebrating-police-appreciation-week-with-custom-coins-ngbm7aenh8r0/index.md':
        return '/blog/celebrating-police-appreciation-week-with-custom-coins/';
    case '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl':
        return '/blog/challenge-coin-bottle-openers-are-functional-and-durable/';
    case '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl/index':
        return '/blog/challenge-coin-bottle-openers-are-functional-and-durable/';
    case '/blog/challenge-coin-bottle-openers-are-functional-and-durable-ngbm3e261ypl/index.md':
        return '/blog/challenge-coin-bottle-openers-are-functional-and-durable/';
    case '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79':
        return '/blog/challenge-coins-101-your-art-proof/';
    case '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79/index':
        return '/blog/challenge-coins-101-your-art-proof/';
    case '/blog/challenge-coins-101-your-art-proof-ngbm66eh1v79/index.md':
        return '/blog/challenge-coins-101-your-art-proof/';
    case '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j':
        return '/blog/challenge-coins-celebrating-history-and-legacy/';
    case '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j/index':
        return '/blog/challenge-coins-celebrating-history-and-legacy/';
    case '/blog/challenge-coins-celebrating-history-and-legacy-ngimmlax0c8j/index.md':
        return '/blog/challenge-coins-celebrating-history-and-legacy/';
    case '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh':
        return '/blog/challenge-coins-for-the-danimal/';
    case '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh/index':
        return '/blog/challenge-coins-for-the-danimal/';
    case '/blog/challenge-coins-for-the-danimal-ngbm8vs6yveh/index.md':
        return '/blog/challenge-coins-for-the-danimal/';
    case '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj':
        return '/blog/challenge-coins-for-the-industry/';
    case '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj/index':
        return '/blog/challenge-coins-for-the-industry/';
    case '/blog/challenge-coins-for-the-industry-ngbm4hw7l1vj/index.md':
        return '/blog/challenge-coins-for-the-industry/';
    case '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3':
        return '/blog/challenge-coins-for-your-conferences-and-conventions/';
    case '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3/index':
        return '/blog/challenge-coins-for-your-conferences-and-conventions/';
    case '/blog/challenge-coins-for-your-conferences-and-conventions-ngbm4jc1wso3/index.md':
        return '/blog/challenge-coins-for-your-conferences-and-conventions/';
    case '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58':
        return '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field/';
    case '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58/index':
        return '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field/';
    case '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field-ngbm4nt2hu58/index.md':
        return '/blog/challenge-coins-help-celebrate-retirement-from-the-military-or-public-service-field/';
    case '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs':
        return '/blog/challenge-coins-that-fly-in-formation/';
    case '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs/index':
        return '/blog/challenge-coins-that-fly-in-formation/';
    case '/blog/challenge-coins-that-fly-in-formation-nko5bummasfs/index.md':
        return '/blog/challenge-coins-that-fly-in-formation/';
    case '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9':
        return '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins/';
    case '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9/index':
        return '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins/';
    case '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins-ngbm28h0vrq9/index.md':
        return '/blog/cherry-crest-adventure-farm-offers-quarterly-review-award-lapel-pins/';
    case '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8':
        return '/blog/choosing-a-crowdfunding-platform-for-custom-pins/';
    case '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8/index':
        return '/blog/choosing-a-crowdfunding-platform-for-custom-pins/';
    case '/blog/choosing-a-crowdfunding-platform-for-custom-pins-ngbm1p2fqpi8/index.md':
        return '/blog/choosing-a-crowdfunding-platform-for-custom-pins/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9/index':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1-ngbm6c7y69n9/index.md':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-1/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26/index':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2-ngbm6fho1n26/index.md':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-2/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j/index':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins/';
    case '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins-ngbm6a9kyb7j/index.md':
        return '/blog/choosing-the-right-pin-soft-enamel-vs-die-struck-pins/';
    case '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7':
        return '/blog/christopher-and-dana-reeve-foundation-challenge-coin/';
    case '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7/index':
        return '/blog/christopher-and-dana-reeve-foundation-challenge-coin/';
    case '/blog/christopher-and-dana-reeve-foundation-challenge-coin-ngbm26khcha7/index.md':
        return '/blog/christopher-and-dana-reeve-foundation-challenge-coin/';
    case '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag':
        return '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers/';
    case '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag/index':
        return '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers/';
    case '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers-ngbm3u9bdzag/index.md':
        return '/blog/churchs-chicken-creates-custom-lapel-pins-for-team-trainers/';
    case '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk':
        return '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful/';
    case '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk/index':
        return '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful/';
    case '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful-ngbm29oz71sk/index.md':
        return '/blog/cincinnati-ohio-lapel-pins-are-distinct-and-meaningful/';
    case '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa':
        return '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins/';
    case '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa/index':
        return '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins/';
    case '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins-ngbm2n3bq2fa/index.md':
        return '/blog/city-of-cottonwoods-exclusive-collectible-challenge-coins/';
    case '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk':
        return '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins/';
    case '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk/index':
        return '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins/';
    case '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins-ngbm8m28a3wk/index.md':
        return '/blog/coins-of-courage-the-tradition-of-custom-military-challenge-coins/';
    case '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx':
        return '/blog/colonial-highland-gathering-lapel-pins/';
    case '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx/index':
        return '/blog/colonial-highland-gathering-lapel-pins/';
    case '/blog/colonial-highland-gathering-lapel-pins-ngbm38vph3dx/index.md':
        return '/blog/colonial-highland-gathering-lapel-pins/';
    case '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i':
        return '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins/';
    case '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i/index':
        return '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins/';
    case '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins-ngbm3xyc334i/index.md':
        return '/blog/conocophillips-awards-safety-with-unique-custom-challenge-coins/';
    case '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i':
        return '/blog/cooper-finn-raises-money-for-childhood-cancer/';
    case '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i/index':
        return '/blog/cooper-finn-raises-money-for-childhood-cancer/';
    case '/blog/cooper-finn-raises-money-for-childhood-cancer-ngbm8soet29i/index.md':
        return '/blog/cooper-finn-raises-money-for-childhood-cancer/';
    case '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe':
        return '/blog/corporate-achievements-make-interesting-challenge-coin-designs/';
    case '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe/index':
        return '/blog/corporate-achievements-make-interesting-challenge-coin-designs/';
    case '/blog/corporate-achievements-make-interesting-challenge-coin-designs-ngbm122hz9pe/index.md':
        return '/blog/corporate-achievements-make-interesting-challenge-coin-designs/';
    case '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41':
        return '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins/';
    case '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41/index':
        return '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins/';
    case '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins-ngbm2zurgq41/index.md':
        return '/blog/corporations-welcome-veterans-into-the-workforce-with-custom-challenge-coins/';
    case '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj':
        return '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey/';
    case '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj/index':
        return '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey/';
    case '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey-ngbm2yfkl7fj/index.md':
        return '/blog/corpus-christis-destination-imagination-team-get-custom-lapel-pins-for-the-journey/';
    case '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx':
        return '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest/';
    case '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx/index':
        return '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest/';
    case '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest-ngbm5p2us7mx/index.md':
        return '/blog/crafting-connections-with-custom-enamel-pins-at-trikefest/';
    case '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr':
        return '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins/';
    case '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr/index':
        return '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins/';
    case '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins-ngbm5urjpmmr/index.md':
        return '/blog/crafting-your-fandom-elevate-your-passion-with-custom-enamel-fan-merch-pins/';
    case '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde':
        return '/blog/create-christmas-party-challenge-coins-this-year/';
    case '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde/index':
        return '/blog/create-christmas-party-challenge-coins-this-year/';
    case '/blog/create-christmas-party-challenge-coins-this-year-ngbm3k40ijde/index.md':
        return '/blog/create-christmas-party-challenge-coins-this-year/';
    case '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr':
        return '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it/';
    case '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr/index':
        return '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it/';
    case '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it-ngbm1d9ttffr/index.md':
        return '/blog/create-custom-cardstock-with-your-companys-mission-statement-on-it/';
    case '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h':
        return '/blog/create-custom-challenge-coins-to-honor-your-star-students/';
    case '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h/index':
        return '/blog/create-custom-challenge-coins-to-honor-your-star-students/';
    case '/blog/create-custom-challenge-coins-to-honor-your-star-students-ngbm2kktog1h/index.md':
        return '/blog/create-custom-challenge-coins-to-honor-your-star-students/';
    case '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac':
        return '/blog/create-custom-lapel-pins-for-department-store-day/';
    case '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac/index':
        return '/blog/create-custom-lapel-pins-for-department-store-day/';
    case '/blog/create-custom-lapel-pins-for-department-store-day-ngbm2p0q9zac/index.md':
        return '/blog/create-custom-lapel-pins-for-department-store-day/';
    case '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt':
        return '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week/';
    case '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt/index':
        return '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week/';
    case '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week-ngbm15jigpdt/index.md':
        return '/blog/create-custom-lapel-pins-for-exhibitor-appreciation-week/';
    case '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5':
        return '/blog/create-custom-lapel-pins-for-international-housekeepers-month/';
    case '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5/index':
        return '/blog/create-custom-lapel-pins-for-international-housekeepers-month/';
    case '/blog/create-custom-lapel-pins-for-international-housekeepers-month-ngbm32x05xl5/index.md':
        return '/blog/create-custom-lapel-pins-for-international-housekeepers-month/';
    case '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx':
        return '/blog/create-custom-lapel-pins-for-national-book-month/';
    case '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx/index':
        return '/blog/create-custom-lapel-pins-for-national-book-month/';
    case '/blog/create-custom-lapel-pins-for-national-book-month-ngbm497c8sbx/index.md':
        return '/blog/create-custom-lapel-pins-for-national-book-month/';
    case '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2':
        return '/blog/create-custom-lapel-pins-for-national-chocolate-day/';
    case '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2/index':
        return '/blog/create-custom-lapel-pins-for-national-chocolate-day/';
    case '/blog/create-custom-lapel-pins-for-national-chocolate-day-ngbm2o5edpz2/index.md':
        return '/blog/create-custom-lapel-pins-for-national-chocolate-day/';
    case '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy':
        return '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week/';
    case '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy/index':
        return '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week/';
    case '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week-ngbm497rl4sy/index.md':
        return '/blog/create-custom-lapel-pins-for-national-secondhand-wardrobe-week/';
    case '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c':
        return '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day/';
    case '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c/index':
        return '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day/';
    case '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day-ngbm2jquf20c/index.md':
        return '/blog/create-custom-lapel-pins-for-paraprofessional-appreciation-day/';
    case '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei':
        return '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration/';
    case '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei/index':
        return '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration/';
    case '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration-ngbm3ho38qei/index.md':
        return '/blog/create-custom-lapel-pins-for-your-fourth-of-july-celebration/';
    case '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18':
        return '/blog/create-custom-lapel-pins-for-your-home-improvement-store/';
    case '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18/index':
        return '/blog/create-custom-lapel-pins-for-your-home-improvement-store/';
    case '/blog/create-custom-lapel-pins-for-your-home-improvement-store-ngbm4gjazm18/index.md':
        return '/blog/create-custom-lapel-pins-for-your-home-improvement-store/';
    case '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm':
        return '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop/';
    case '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm/index':
        return '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop/';
    case '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop-ngbm3yzov5rm/index.md':
        return '/blog/create-custom-lapel-pins-for-your-las-vegas-nevada-business-or-souvenir-shop/';
    case '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32':
        return '/blog/create-custom-lapel-pins-for-your-next-convention/';
    case '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32/index':
        return '/blog/create-custom-lapel-pins-for-your-next-convention/';
    case '/blog/create-custom-lapel-pins-for-your-next-convention-ngbm3gdmcj32/index.md':
        return '/blog/create-custom-lapel-pins-for-your-next-convention/';
    case '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo':
        return '/blog/create-custom-lapel-pins-for-your-open-house/';
    case '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo/index':
        return '/blog/create-custom-lapel-pins-for-your-open-house/';
    case '/blog/create-custom-lapel-pins-for-your-open-house-ngbm2a5jo3bo/index.md':
        return '/blog/create-custom-lapel-pins-for-your-open-house/';
    case '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68':
        return '/blog/create-custom-lapel-pins-for-your-pizzeria/';
    case '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68/index':
        return '/blog/create-custom-lapel-pins-for-your-pizzeria/';
    case '/blog/create-custom-lapel-pins-for-your-pizzeria-ngbm3ntnml68/index.md':
        return '/blog/create-custom-lapel-pins-for-your-pizzeria/';
    case '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99':
        return '/blog/create-custom-lapel-pins-for-your-student-ambassador-program/';
    case '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99/index':
        return '/blog/create-custom-lapel-pins-for-your-student-ambassador-program/';
    case '/blog/create-custom-lapel-pins-for-your-student-ambassador-program-ngbm3u9l3y99/index.md':
        return '/blog/create-custom-lapel-pins-for-your-student-ambassador-program/';
    case '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02':
        return '/blog/create-custom-lapel-pins-for-your-watermelon-feed/';
    case '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02/index':
        return '/blog/create-custom-lapel-pins-for-your-watermelon-feed/';
    case '/blog/create-custom-lapel-pins-for-your-watermelon-feed-ngbm3dnkhb02/index.md':
        return '/blog/create-custom-lapel-pins-for-your-watermelon-feed/';
    case '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek':
        return '/blog/create-custom-lapel-pins-for-youth-leadership-month/';
    case '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek/index':
        return '/blog/create-custom-lapel-pins-for-youth-leadership-month/';
    case '/blog/create-custom-lapel-pins-for-youth-leadership-month-ngbm30jipkek/index.md':
        return '/blog/create-custom-lapel-pins-for-youth-leadership-month/';
    case '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt':
        return '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash/';
    case '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt/index':
        return '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash/';
    case '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash-ngbm4fdxvgqt/index.md':
        return '/blog/create-custom-lapel-pins-to-announce-your-church-car-wash/';
    case '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5':
        return '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city/';
    case '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5/index':
        return '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city/';
    case '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city-ngbm4mp14jg5/index.md':
        return '/blog/create-custom-lapel-pins-to-honor-the-coaches-in-your-city/';
    case '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc':
        return '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day/';
    case '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc/index':
        return '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day/';
    case '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day-ngbm2lrssgoc/index.md':
        return '/blog/create-custom-lapel-pins-to-honor-your-loved-one-on-memorial-day/';
    case '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l':
        return '/blog/create-custom-lapel-pins-to-promote-national-coupon-month/';
    case '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l/index':
        return '/blog/create-custom-lapel-pins-to-promote-national-coupon-month/';
    case '/blog/create-custom-lapel-pins-to-promote-national-coupon-month-ngbm4b4x393l/index.md':
        return '/blog/create-custom-lapel-pins-to-promote-national-coupon-month/';
    case '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0':
        return '/blog/create-custom-lapel-pins-to-promote-your-catering-business/';
    case '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0/index':
        return '/blog/create-custom-lapel-pins-to-promote-your-catering-business/';
    case '/blog/create-custom-lapel-pins-to-promote-your-catering-business-ngbm4p4t0ud0/index.md':
        return '/blog/create-custom-lapel-pins-to-promote-your-catering-business/';
    case '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884':
        return '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities/';
    case '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884/index':
        return '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities/';
    case '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities-ngbm1d6tu884/index.md':
        return '/blog/create-custom-lapel-pins-to-promote-your-musical-abilities/';
    case '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o':
        return '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company/';
    case '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o/index':
        return '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company/';
    case '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company-ngbm1sqdu61o/index.md':
        return '/blog/create-custom-lapel-pins-to-promote-your-skydiving-company/';
    case '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1':
        return '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp/';
    case '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1/index':
        return '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp/';
    case '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp-ngbm4s7foun1/index.md':
        return '/blog/create-custom-lapel-pins-to-trade-with-other-campers-at-summer-camp/';
    case '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh':
        return '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys/';
    case '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh/index':
        return '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys/';
    case '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys-ngbm3gdwkzvh/index.md':
        return '/blog/create-custom-lapel-pins-to-use-as-thank-you-gifts-for-customers-that-complete-surveys/';
    case '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki':
        return '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser/';
    case '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki/index':
        return '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser/';
    case '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser-ngbm4lld3gki/index.md':
        return '/blog/create-custom-poker-coins-and-card-guards-for-your-casino-or-fundraiser/';
    case '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e':
        return '/blog/create-years-of-service-award-lapel-pins-for-your-company/';
    case '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e/index':
        return '/blog/create-years-of-service-award-lapel-pins-for-your-company/';
    case '/blog/create-years-of-service-award-lapel-pins-for-your-company-ngbm2gmbnr1e/index.md':
        return '/blog/create-years-of-service-award-lapel-pins-for-your-company/';
    case '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py':
        return '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials/';
    case '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py/index':
        return '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials/';
    case '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials-ngbm17d6m0py/index.md':
        return '/blog/creating-custom-lapel-pins-for-veterans-and-officer-memorials/';
    case '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in':
        return '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration/';
    case '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in/index':
        return '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration/';
    case '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration-ngbm16n772in/index.md':
        return '/blog/creating-patriotic-lapel-pins-for-your-fourth-of-july-celebration/';
    case '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6':
        return '/blog/cruising-ducks-custom-pins-keychains-coins/';
    case '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6/index':
        return '/blog/cruising-ducks-custom-pins-keychains-coins/';
    case '/blog/cruising-ducks-custom-pins-keychains-coins-ngbm5gveqfj6/index.md':
        return '/blog/cruising-ducks-custom-pins-keychains-coins/';
    case '/blog/custom-attraction-lapel-pins-ngbm191bx0xc':
        return '/blog/custom-attraction-lapel-pins/';
    case '/blog/custom-attraction-lapel-pins-ngbm191bx0xc/index':
        return '/blog/custom-attraction-lapel-pins/';
    case '/blog/custom-attraction-lapel-pins-ngbm191bx0xc/index.md':
        return '/blog/custom-attraction-lapel-pins/';
    case '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv':
        return '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins/';
    case '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv/index':
        return '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins/';
    case '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins-ngbm2tr06rzv/index.md':
        return '/blog/custom-backstamp-add-a-personalized-touch-to-your-lapel-pins/';
    case '/blog/custom-challenge-coin-01-ngbm716lar18':
        return '/blog/custom-challenge-coin-01/';
    case '/blog/custom-challenge-coin-01-ngbm716lar18/index':
        return '/blog/custom-challenge-coin-01/';
    case '/blog/custom-challenge-coin-01-ngbm716lar18/index.md':
        return '/blog/custom-challenge-coin-01/';
    case '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi':
        return '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq/';
    case '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi/index':
        return '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq/';
    case '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq-ngbm4vm3b3mi/index.md':
        return '/blog/custom-challenge-coin-bottle-openers-frequently-asked-questions-faq/';
    case '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl':
        return '/blog/custom-challenge-coins-are-perfect-for-self-promotion/';
    case '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl/index':
        return '/blog/custom-challenge-coins-are-perfect-for-self-promotion/';
    case '/blog/custom-challenge-coins-are-perfect-for-self-promotion-ngbm3wco84sl/index.md':
        return '/blog/custom-challenge-coins-are-perfect-for-self-promotion/';
    case '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr':
        return '/blog/custom-challenge-coins-for-grand-openings/';
    case '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr/index':
        return '/blog/custom-challenge-coins-for-grand-openings/';
    case '/blog/custom-challenge-coins-for-grand-openings-ngbm2l7e1rmr/index.md':
        return '/blog/custom-challenge-coins-for-grand-openings/';
    case '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b':
        return '/blog/custom-challenge-coins-for-your-casino/';
    case '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b/index':
        return '/blog/custom-challenge-coins-for-your-casino/';
    case '/blog/custom-challenge-coins-for-your-casino-ngbm417rap7b/index.md':
        return '/blog/custom-challenge-coins-for-your-casino/';
    case '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6':
        return '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime/';
    case '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6/index':
        return '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime/';
    case '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime-ngbm626v36p6/index.md':
        return '/blog/custom-challenge-coins-help-new-years-resolutions-last-a-lifetime/';
    case '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u':
        return '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch/';
    case '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u/index':
        return '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch/';
    case '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch-ngbm241c2q3u/index.md':
        return '/blog/custom-challenge-coins-made-to-commemorate-nrol-32-launch/';
    case '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33':
        return '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls/';
    case '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33/index':
        return '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls/';
    case '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls-ngbm2h3hhk33/index.md':
        return '/blog/custom-challenge-coins-make-great-memorabilia-for-us-navy-balls-and-us-marine-corps-balls/';
    case '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni':
        return '/custom-challenge-coins/3d-challenge-coins/';
    case '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni/index':
        return '/custom-challenge-coins/3d-challenge-coins/';
    case '/blog/custom-challenge-coins/3d-challenge-coins-ngbm62i61eni/index.md':
        return '/custom-challenge-coins/3d-challenge-coins/';
    case '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas':
        return '/custom-challenge-coins/commemorative-challenge-coins/';
    case '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas/index':
        return '/custom-challenge-coins/commemorative-challenge-coins/';
    case '/blog/custom-challenge-coins/commemorative-challenge-coins-ngbm7ibkiaas/index.md':
        return '/custom-challenge-coins/commemorative-challenge-coins/';
    case '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq':
        return '/custom-challenge-coins/corporate-challenge-coins-0/';
    case '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq/index':
        return '/custom-challenge-coins/corporate-challenge-coins-0/';
    case '/blog/custom-challenge-coins/corporate-challenge-coins-0-ngbm71l6y4oq/index.md':
        return '/custom-challenge-coins/corporate-challenge-coins-0/';
    case '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk':
        return '/custom-challenge-coins/corporate-challenge-coins/';
    case '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk/index':
        return '/custom-challenge-coins/corporate-challenge-coins/';
    case '/blog/custom-challenge-coins/corporate-challenge-coins-ngbm7m5vodtk/index.md':
        return '/custom-challenge-coins/corporate-challenge-coins/';
    case '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86':
        return '/custom-challenge-coins/custom-bottle-openers/';
    case '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86/index':
        return '/custom-challenge-coins/custom-bottle-openers/';
    case '/blog/custom-challenge-coins/custom-bottle-openers-ngbm7xdmll86/index.md':
        return '/custom-challenge-coins/custom-bottle-openers/';
    case '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd':
        return '/custom-challenge-coins/custom-university-challenge-coins/';
    case '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd/index':
        return '/custom-challenge-coins/custom-university-challenge-coins/';
    case '/blog/custom-challenge-coins/custom-university-challenge-coins-ngbm7gu1fphd/index.md':
        return '/custom-challenge-coins/custom-university-challenge-coins/';
    case '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe':
        return '/custom-challenge-coins/custom-wholesale-coins/';
    case '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe/index':
        return '/custom-challenge-coins/custom-wholesale-coins/';
    case '/blog/custom-challenge-coins/custom-wholesale-coins-ngbm8hqkciwe/index.md':
        return '/custom-challenge-coins/custom-wholesale-coins/';
    case '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w':
        return '/custom-challenge-coins/ems-challenge-coins/';
    case '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w/index':
        return '/custom-challenge-coins/ems-challenge-coins/';
    case '/blog/custom-challenge-coins/ems-challenge-coins-ngbm7pcf8z7w/index.md':
        return '/custom-challenge-coins/ems-challenge-coins/';
    case '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc':
        return '/custom-challenge-coins/firefighter-challenge-coins-0/';
    case '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc/index':
        return '/custom-challenge-coins/firefighter-challenge-coins-0/';
    case '/blog/custom-challenge-coins/firefighter-challenge-coins-0-ngbm8cxb90jc/index.md':
        return '/custom-challenge-coins/firefighter-challenge-coins-0/';
    case '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z':
        return '/custom-challenge-coins/firefighter-challenge-coins/';
    case '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z/index':
        return '/custom-challenge-coins/firefighter-challenge-coins/';
    case '/blog/custom-challenge-coins/firefighter-challenge-coins-ngbm7im75z6z/index.md':
        return '/custom-challenge-coins/firefighter-challenge-coins/';
    case '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50':
        return '/custom-challenge-coins/govt-challenge-coins/';
    case '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50/index':
        return '/custom-challenge-coins/govt-challenge-coins/';
    case '/blog/custom-challenge-coins/govt-challenge-coins-ngbm7rfzpl50/index.md':
        return '/custom-challenge-coins/govt-challenge-coins/';
    case '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat':
        return '/custom-challenge-coins/law-enforcement-challenge-coins-0/';
    case '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat/index':
        return '/custom-challenge-coins/law-enforcement-challenge-coins-0/';
    case '/blog/custom-challenge-coins/law-enforcement-challenge-coins-0-ngbm7teaquat/index.md':
        return '/custom-challenge-coins/law-enforcement-challenge-coins-0/';
    case '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo':
        return '/custom-challenge-coins/law-enforcement-challenge-coins/';
    case '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo/index':
        return '/custom-challenge-coins/law-enforcement-challenge-coins/';
    case '/blog/custom-challenge-coins/law-enforcement-challenge-coins-ngbm7mszeewo/index.md':
        return '/custom-challenge-coins/law-enforcement-challenge-coins/';
    case '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4':
        return '/custom-challenge-coins/marine-challenge-coins/';
    case '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4/index':
        return '/custom-challenge-coins/marine-challenge-coins/';
    case '/blog/custom-challenge-coins/marine-challenge-coins-ngbm7stbrmz4/index.md':
        return '/custom-challenge-coins/marine-challenge-coins/';
    case '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv':
        return '/custom-challenge-coins/military-challenge-coins-0/';
    case '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv/index':
        return '/custom-challenge-coins/military-challenge-coins-0/';
    case '/blog/custom-challenge-coins/military-challenge-coins-0-ngbm8cck04bv/index.md':
        return '/custom-challenge-coins/military-challenge-coins-0/';
    case '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b':
        return '/custom-challenge-coins/police-challenge-coins/';
    case '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b/index':
        return '/custom-challenge-coins/police-challenge-coins/';
    case '/blog/custom-challenge-coins/police-challenge-coins-ngbm7ec49o6b/index.md':
        return '/custom-challenge-coins/police-challenge-coins/';
    case '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu':
        return '/custom-challenge-coins/religious-challenge-coins/';
    case '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu/index':
        return '/custom-challenge-coins/religious-challenge-coins/';
    case '/blog/custom-challenge-coins/religious-challenge-coins-ngbm7vh3j0hu/index.md':
        return '/custom-challenge-coins/religious-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh':
        return '/custom-challenge-coins/seo-coast-guard-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh/index':
        return '/custom-challenge-coins/seo-coast-guard-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-coast-guard-challenge-coins-ngbm8h6xrrxh/index.md':
        return '/custom-challenge-coins/seo-coast-guard-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf':
        return '/custom-challenge-coins/seo-finance-firm-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf/index':
        return '/custom-challenge-coins/seo-finance-firm-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-finance-firm-challenge-coins-ngbm7648a1tf/index.md':
        return '/custom-challenge-coins/seo-finance-firm-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo':
        return '/custom-challenge-coins/seo-game-industry-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo/index':
        return '/custom-challenge-coins/seo-game-industry-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-game-industry-challenge-coins-ngbm8e5w9oyo/index.md':
        return '/custom-challenge-coins/seo-game-industry-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu':
        return '/custom-challenge-coins/seo-highway-patrol-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu/index':
        return '/custom-challenge-coins/seo-highway-patrol-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-highway-patrol-challenge-coins-ngbm8ka1xrbu/index.md':
        return '/custom-challenge-coins/seo-highway-patrol-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq':
        return '/custom-challenge-coins/seo-navy-seal-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq/index':
        return '/custom-challenge-coins/seo-navy-seal-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-navy-seal-challenge-coins-ngbm76dcnkiq/index.md':
        return '/custom-challenge-coins/seo-navy-seal-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib':
        return '/custom-challenge-coins/seo-non-profit-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib/index':
        return '/custom-challenge-coins/seo-non-profit-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-non-profit-challenge-coins-ngbm74a1zzib/index.md':
        return '/custom-challenge-coins/seo-non-profit-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx':
        return '/custom-challenge-coins/seo-park-police-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx/index':
        return '/custom-challenge-coins/seo-park-police-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-park-police-challenge-coins-ngbm79wfiyjx/index.md':
        return '/custom-challenge-coins/seo-park-police-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw':
        return '/custom-challenge-coins/seo-police-academy-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw/index':
        return '/custom-challenge-coins/seo-police-academy-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-police-academy-challenge-coins-ngbm784usnlw/index.md':
        return '/custom-challenge-coins/seo-police-academy-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r':
        return '/custom-challenge-coins/seo-state-police-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r/index':
        return '/custom-challenge-coins/seo-state-police-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-state-police-challenge-coins-ngbm73otd42r/index.md':
        return '/custom-challenge-coins/seo-state-police-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh':
        return '/custom-challenge-coins/seo-tech-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh/index':
        return '/custom-challenge-coins/seo-tech-challenge-coins/';
    case '/blog/custom-challenge-coins/seo-tech-challenge-coins-ngbm7z2bhedh/index.md':
        return '/custom-challenge-coins/seo-tech-challenge-coins/';
    case '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9':
        return '/custom-challenge-coins/sports-challenge-coins/';
    case '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9/index':
        return '/custom-challenge-coins/sports-challenge-coins/';
    case '/blog/custom-challenge-coins/sports-challenge-coins-ngbm7j6m0mn9/index.md':
        return '/custom-challenge-coins/sports-challenge-coins/';
    case '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme':
        return '/custom-challenge-coins/state-department-challenge-coins/';
    case '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme/index':
        return '/custom-challenge-coins/state-department-challenge-coins/';
    case '/blog/custom-challenge-coins/state-department-challenge-coins-ngbm7uzvmyme/index.md':
        return '/custom-challenge-coins/state-department-challenge-coins/';
    case '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla':
        return '/custom-challenge-coins/veterans-challenge-coins/';
    case '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla/index':
        return '/custom-challenge-coins/veterans-challenge-coins/';
    case '/blog/custom-challenge-coins/veterans-challenge-coins-ngbm7oxa5fla/index.md':
        return '/custom-challenge-coins/veterans-challenge-coins/';
    case '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb':
        return '/blog/custom-coin-design-high-polish-challenge-coins/';
    case '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb/index':
        return '/blog/custom-coin-design-high-polish-challenge-coins/';
    case '/blog/custom-coin-design-high-polish-challenge-coins-ngbm656dq3zb/index.md':
        return '/blog/custom-coin-design-high-polish-challenge-coins/';
    case '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm':
        return '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers/';
    case '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm/index':
        return '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers/';
    case '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers-ngbm43myxzzm/index.md':
        return '/blog/custom-colorado-lapel-pins-make-great-souvenirs-for-all-ages-of-travelers/';
    case '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8':
        return '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association/';
    case '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8/index':
        return '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association/';
    case '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association-ngbm4dh225y8/index.md':
        return '/blog/custom-convention-pins-for-chapter-15-of-the-international-footprint-association/';
    case '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y':
        return '/blog/custom-edm-pins-for-sodown/';
    case '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y/index':
        return '/blog/custom-edm-pins-for-sodown/';
    case '/blog/custom-edm-pins-for-sodown-ngbm58mbfy8y/index.md':
        return '/blog/custom-edm-pins-for-sodown/';
    case '/blog/custom-fraternity-pins-ngbm6hksaxfp':
        return '/blog/custom-fraternity-pins/';
    case '/blog/custom-fraternity-pins-ngbm6hksaxfp/index':
        return '/blog/custom-fraternity-pins/';
    case '/blog/custom-fraternity-pins-ngbm6hksaxfp/index.md':
        return '/blog/custom-fraternity-pins/';
    case '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw':
        return '/blog/custom-hard-enamel-pins-a-guide/';
    case '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw/index':
        return '/blog/custom-hard-enamel-pins-a-guide/';
    case '/blog/custom-hard-enamel-pins-a-guide-ngbm5zfvnxmw/index.md':
        return '/blog/custom-hard-enamel-pins-a-guide/';
    case '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio':
        return '/blog/custom-krewe-pins-a-carnival-parade-tradition/';
    case '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio/index':
        return '/blog/custom-krewe-pins-a-carnival-parade-tradition/';
    case '/blog/custom-krewe-pins-a-carnival-parade-tradition-ngbm2us4osio/index.md':
        return '/blog/custom-krewe-pins-a-carnival-parade-tradition/';
    case '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh':
        return '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show/';
    case '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh/index':
        return '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show/';
    case '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show-ngbm4khjfijh/index.md':
        return '/blog/custom-lanyards-are-fitting-for-events-like-the-international-consumer-electronics-show/';
    case '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu':
        return '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2/';
    case '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu/index':
        return '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2/';
    case '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2-ngbm3dnuxysu/index.md':
        return '/blog/custom-lanyards-make-the-perfect-giveaway-item-for-trade-shows-2/';
    case '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf':
        return '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world/';
    case '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf/index':
        return '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world/';
    case '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world-ngbm2qq9ffkf/index.md':
        return '/blog/custom-lapel-pin-use-in-remembrance-and-armistice-day-celebrations-around-the-world/';
    case '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs':
        return '/blog/custom-lapel-pins-for-corporate-sponsored-activities/';
    case '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs/index':
        return '/blog/custom-lapel-pins-for-corporate-sponsored-activities/';
    case '/blog/custom-lapel-pins-for-corporate-sponsored-activities-ngbm3hotkvjs/index.md':
        return '/blog/custom-lapel-pins-for-corporate-sponsored-activities/';
    case '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67':
        return '/blog/custom-lapel-pins-for-your-county-or-state-fair/';
    case '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67/index':
        return '/blog/custom-lapel-pins-for-your-county-or-state-fair/';
    case '/blog/custom-lapel-pins-for-your-county-or-state-fair-ngbm3cftaz67/index.md':
        return '/blog/custom-lapel-pins-for-your-county-or-state-fair/';
    case '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t':
        return '/blog/custom-lapel-pins-help-identify-rescue-workers/';
    case '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t/index':
        return '/blog/custom-lapel-pins-help-identify-rescue-workers/';
    case '/blog/custom-lapel-pins-help-identify-rescue-workers-ngbm5c632s4t/index.md':
        return '/blog/custom-lapel-pins-help-identify-rescue-workers/';
    case '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98':
        return '/blog/custom-lapel-pins-help-identify-very-important-people/';
    case '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98/index':
        return '/blog/custom-lapel-pins-help-identify-very-important-people/';
    case '/blog/custom-lapel-pins-help-identify-very-important-people-ngbm2b9ptx98/index.md':
        return '/blog/custom-lapel-pins-help-identify-very-important-people/';
    case '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw':
        return '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds/';
    case '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw/index':
        return '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds/';
    case '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds-ngbm1hh8rbvw/index.md':
        return '/blog/custom-lapel-pins-make-perfect-gifts-for-rock-collectors-and-rock-hounds/';
    case '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c':
        return '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament/';
    case '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c/index':
        return '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament/';
    case '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament-ngbm2zkv7g0c/index.md':
        return '/blog/custom-lapel-pins-score-big-at-the-pebble-beach-golf-tournament/';
    case '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn':
        return '/blog/custom-lapel-pins-to-promote-public-transportation/';
    case '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn/index':
        return '/blog/custom-lapel-pins-to-promote-public-transportation/';
    case '/blog/custom-lapel-pins-to-promote-public-transportation-ngbm4s64i0zn/index.md':
        return '/blog/custom-lapel-pins-to-promote-public-transportation/';
    case '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az':
        return '/blog/custom-lapel-pins-with-mottos-offer-encouragement/';
    case '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az/index':
        return '/blog/custom-lapel-pins-with-mottos-offer-encouragement/';
    case '/blog/custom-lapel-pins-with-mottos-offer-encouragement-ngbm31usd8az/index.md':
        return '/blog/custom-lapel-pins-with-mottos-offer-encouragement/';
    case '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u':
        return '/custom-lapel-pins/custom-flag-pins/';
    case '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u/index':
        return '/custom-lapel-pins/custom-flag-pins/';
    case '/blog/custom-lapel-pins/custom-flag-pins-ngbm5so9qc5u/index.md':
        return '/custom-lapel-pins/custom-flag-pins/';
    case '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute':
        return '/custom-lapel-pins/custom-fraternity-pins/';
    case '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute/index':
        return '/custom-lapel-pins/custom-fraternity-pins/';
    case '/blog/custom-lapel-pins/custom-fraternity-pins-ngbm6jv51ute/index.md':
        return '/custom-lapel-pins/custom-fraternity-pins/';
    case '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl':
        return '/custom-lapel-pins/custom-masonic-pins/';
    case '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl/index':
        return '/custom-lapel-pins/custom-masonic-pins/';
    case '/blog/custom-lapel-pins/custom-masonic-pins-ngbm5fhhucdl/index.md':
        return '/custom-lapel-pins/custom-masonic-pins/';
    case '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57':
        return '/custom-lapel-pins/custom-military-pins/';
    case '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57/index':
        return '/custom-lapel-pins/custom-military-pins/';
    case '/blog/custom-lapel-pins/custom-military-pins-ngbm091ngj57/index.md':
        return '/custom-lapel-pins/custom-military-pins/';
    case '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1':
        return '/custom-lapel-pins/custom-sorority-pins/';
    case '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1/index':
        return '/custom-lapel-pins/custom-sorority-pins/';
    case '/blog/custom-lapel-pins/custom-sorority-pins-ngbm6mv0fht1/index.md':
        return '/custom-lapel-pins/custom-sorority-pins/';
    case '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf':
        return '/custom-lapel-pins/logo-pins/';
    case '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf/index':
        return '/custom-lapel-pins/logo-pins/';
    case '/blog/custom-lapel-pins/logo-pins-ngbm5qk32qvf/index.md':
        return '/custom-lapel-pins/logo-pins/';
    case '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0':
        return '/custom-lapel-pins/school-pins/';
    case '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0/index':
        return '/custom-lapel-pins/school-pins/';
    case '/blog/custom-lapel-pins/school-pins-ngbm06i5djt0/index.md':
        return '/custom-lapel-pins/school-pins/';
    case '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim':
        return '/custom-lapel-pins/years-of-service-pins/';
    case '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim/index':
        return '/custom-lapel-pins/years-of-service-pins/';
    case '/blog/custom-lapel-pins/years-of-service-pins-ngbm06xmkqim/index.md':
        return '/custom-lapel-pins/years-of-service-pins/';
    case '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks':
        return '/blog/custom-minted-challenge-coins-the-new-business-card/';
    case '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks/index':
        return '/blog/custom-minted-challenge-coins-the-new-business-card/';
    case '/blog/custom-minted-challenge-coins-the-new-business-card-ngbm2w70cmks/index.md':
        return '/blog/custom-minted-challenge-coins-the-new-business-card/';
    case '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se':
        return '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission/';
    case '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se/index':
        return '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission/';
    case '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission-ngbvi1l9s7se/index.md':
        return '/blog/custom-nasa-patches-for-the-first-asteroid-sample-return-mission/';
    case '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as':
        return '/blog/custom-pin-design-5-details-to-check-in-your-art-proof/';
    case '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as/index':
        return '/blog/custom-pin-design-5-details-to-check-in-your-art-proof/';
    case '/blog/custom-pin-design-5-details-to-check-in-your-art-proof-ngbm1ucuh1as/index.md':
        return '/blog/custom-pin-design-5-details-to-check-in-your-art-proof/';
    case '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5':
        return '/blog/custom-pin-design-checklist-5-details-to-checkoff/';
    case '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5/index':
        return '/blog/custom-pin-design-checklist-5-details-to-checkoff/';
    case '/blog/custom-pin-design-checklist-5-details-to-checkoff-ngbm1mdk96a5/index.md':
        return '/blog/custom-pin-design-checklist-5-details-to-checkoff/';
    case '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s':
        return '/blog/custom-pins-101-cardstock-backing/';
    case '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s/index':
        return '/blog/custom-pins-101-cardstock-backing/';
    case '/blog/custom-pins-101-cardstock-backing-ngbm1zyu8x7s/index.md':
        return '/blog/custom-pins-101-cardstock-backing/';
    case '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx':
        return '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins/';
    case '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx/index':
        return '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins/';
    case '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins-ngbm1zunfyhx/index.md':
        return '/blog/custom-pins-101-choosing-between-soft-enamel-hard-enamel-and-die-struck-pins/';
    case '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz':
        return '/blog/custom-pins-101-creating-a-lapel-pin-color-palette/';
    case '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz/index':
        return '/blog/custom-pins-101-creating-a-lapel-pin-color-palette/';
    case '/blog/custom-pins-101-creating-a-lapel-pin-color-palette-ngbm1nbl8adz/index.md':
        return '/blog/custom-pins-101-creating-a-lapel-pin-color-palette/';
    case '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef':
        return '/blog/custom-pins-101-sizing-custom-pins/';
    case '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef/index':
        return '/blog/custom-pins-101-sizing-custom-pins/';
    case '/blog/custom-pins-101-sizing-custom-pins-ngbm1p7zwyef/index.md':
        return '/blog/custom-pins-101-sizing-custom-pins/';
    case '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom':
        return '/blog/custom-pins-101-text-and-typography/';
    case '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom/index':
        return '/blog/custom-pins-101-text-and-typography/';
    case '/blog/custom-pins-101-text-and-typography-ngbm1jxwohom/index.md':
        return '/blog/custom-pins-101-text-and-typography/';
    case '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci':
        return '/blog/custom-pins-101-types-of-pin-backs-and-attachments/';
    case '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci/index':
        return '/blog/custom-pins-101-types-of-pin-backs-and-attachments/';
    case '/blog/custom-pins-101-types-of-pin-backs-and-attachments-ngbm1a89osci/index.md':
        return '/blog/custom-pins-101-types-of-pin-backs-and-attachments/';
    case '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc':
        return '/blog/custom-pins-for-christmas-and-the-holidays/';
    case '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc/index':
        return '/blog/custom-pins-for-christmas-and-the-holidays/';
    case '/blog/custom-pins-for-christmas-and-the-holidays-ngbm1yx8emdc/index.md':
        return '/blog/custom-pins-for-christmas-and-the-holidays/';
    case '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag':
        return '/blog/custom-pins-in-the-spirit-of-giving/';
    case '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag/index':
        return '/blog/custom-pins-in-the-spirit-of-giving/';
    case '/blog/custom-pins-in-the-spirit-of-giving-ngbm60r76yag/index.md':
        return '/blog/custom-pins-in-the-spirit-of-giving/';
    case '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c':
        return '/blog/custom-trading-pins-add-ons-and-design-trends/';
    case '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c/index':
        return '/blog/custom-trading-pins-add-ons-and-design-trends/';
    case '/blog/custom-trading-pins-add-ons-and-design-trends-ngbm1cck0g7c/index.md':
        return '/blog/custom-trading-pins-add-ons-and-design-trends/';
    case '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45':
        return '/blog/custom-trading-pins-working-with-a-pin-manufacturer/';
    case '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45/index':
        return '/blog/custom-trading-pins-working-with-a-pin-manufacturer/';
    case '/blog/custom-trading-pins-working-with-a-pin-manufacturer-ngbm1hff4s45/index.md':
        return '/blog/custom-trading-pins-working-with-a-pin-manufacturer/';
    case '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o':
        return '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom/';
    case '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o/index':
        return '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom/';
    case '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom-ngbm137r0q2o/index.md':
        return '/blog/custom-wedding-pins-celebrate-both-the-bride-and-the-groom/';
    case '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7':
        return '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees/';
    case '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7/index':
        return '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees/';
    case '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees-ngbm30i05pn7/index.md':
        return '/blog/custom-years-of-service-lapel-pins-for-california-plant-with-over-200-employees/';
    case '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo':
        return '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent/';
    case '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo/index':
        return '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent/';
    case '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent-ngbm1n7v98oo/index.md':
        return '/blog/custom-youth-art-month-lapel-pins-showcase-young-talent/';
    case '/blog/cutting-edge-coins-ng5ljvadlwqn':
        return '/blog/cutting-edge-coins/';
    case '/blog/cutting-edge-coins-ng5ljvadlwqn/index':
        return '/blog/cutting-edge-coins/';
    case '/blog/cutting-edge-coins-ng5ljvadlwqn/index.md':
        return '/blog/cutting-edge-coins/';
    case '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw':
        return '/blog/designing-custom-cufflinks-with-allaboutpins/';
    case '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw/index':
        return '/blog/designing-custom-cufflinks-with-allaboutpins/';
    case '/blog/designing-custom-cufflinks-with-allaboutpins-ngbm1xfbe9mw/index.md':
        return '/blog/designing-custom-cufflinks-with-allaboutpins/';
    case '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l':
        return '/blog/designing-custom-nurse-lapel-pins/';
    case '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l/index':
        return '/blog/designing-custom-nurse-lapel-pins/';
    case '/blog/designing-custom-nurse-lapel-pins-ngbm1beeu73l/index.md':
        return '/blog/designing-custom-nurse-lapel-pins/';
    case '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q':
        return '/blog/designing-custom-police-challenge-coins/';
    case '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q/index':
        return '/blog/designing-custom-police-challenge-coins/';
    case '/blog/designing-custom-police-challenge-coins-ngbm67a38p9q/index.md':
        return '/blog/designing-custom-police-challenge-coins/';
    case '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z':
        return '/blog/designing-custom-police-k-9-unit-challenge-coins/';
    case '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z/index':
        return '/blog/designing-custom-police-k-9-unit-challenge-coins/';
    case '/blog/designing-custom-police-k-9-unit-challenge-coins-ngbm68aep33z/index.md':
        return '/blog/designing-custom-police-k-9-unit-challenge-coins/';
    case '/blog/designing-custom-promotional-pins-ngbm1kkk89cz':
        return '/blog/designing-custom-promotional-pins/';
    case '/blog/designing-custom-promotional-pins-ngbm1kkk89cz/index':
        return '/blog/designing-custom-promotional-pins/';
    case '/blog/designing-custom-promotional-pins-ngbm1kkk89cz/index.md':
        return '/blog/designing-custom-promotional-pins/';
    case '/blog/designing-custom-trading-pins-ngbm1glw2cg4':
        return '/blog/designing-custom-trading-pins/';
    case '/blog/designing-custom-trading-pins-ngbm1glw2cg4/index':
        return '/blog/designing-custom-trading-pins/';
    case '/blog/designing-custom-trading-pins-ngbm1glw2cg4/index.md':
        return '/blog/designing-custom-trading-pins/';
    case '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q':
        return '/blog/designing-custom-years-of-service-pins/';
    case '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q/index':
        return '/blog/designing-custom-years-of-service-pins/';
    case '/blog/designing-custom-years-of-service-pins-ngbm1lercd4q/index.md':
        return '/blog/designing-custom-years-of-service-pins/';
    case '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg':
        return '/blog/designing-fire-department-challenge-coins/';
    case '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg/index':
        return '/blog/designing-fire-department-challenge-coins/';
    case '/blog/designing-fire-department-challenge-coins-ngbm67yw5zrg/index.md':
        return '/blog/designing-fire-department-challenge-coins/';
    case '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja':
        return '/blog/different-metal-options-for-your-years-of-service-lapel-pins/';
    case '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja/index':
        return '/blog/different-metal-options-for-your-years-of-service-lapel-pins/';
    case '/blog/different-metal-options-for-your-years-of-service-lapel-pins-ngbm46t2hqja/index.md':
        return '/blog/different-metal-options-for-your-years-of-service-lapel-pins/';
    case '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff':
        return '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins/';
    case '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff/index':
        return '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins/';
    case '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins-ngbm6xz5laff/index.md':
        return '/blog/digital-world-real-world-collectables-a-deep-dive-into-warframe-video-game-pins/';
    case '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583':
        return '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors/';
    case '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583/index':
        return '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors/';
    case '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors-ngbm26krb583/index.md':
        return '/blog/director-uses-custom-challenge-coins-as-gifts-for-crew-and-visitors/';
    case '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2':
        return '/blog/dole-hawaii-custom-pins/';
    case '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2/index':
        return '/blog/dole-hawaii-custom-pins/';
    case '/blog/dole-hawaii-custom-pins-ngbm6ndhbhm2/index.md':
        return '/blog/dole-hawaii-custom-pins/';
    case '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0':
        return '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin/';
    case '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0/index':
        return '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin/';
    case '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin-ngbm63p0xgg0/index.md':
        return '/blog/eagles-collide-when-a-boy-scout-troop-gets-their-first-challenge-coin/';
    case '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs':
        return '/blog/elevate-your-brand-with-custom-logo-pins/';
    case '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs/index':
        return '/blog/elevate-your-brand-with-custom-logo-pins/';
    case '/blog/elevate-your-brand-with-custom-logo-pins-ngbm5x3ivrjs/index.md':
        return '/blog/elevate-your-brand-with-custom-logo-pins/';
    case '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g':
        return '/blog/emergency-nurses-day-custom-lapel-pins/';
    case '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g/index':
        return '/blog/emergency-nurses-day-custom-lapel-pins/';
    case '/blog/emergency-nurses-day-custom-lapel-pins-ngbm12r96p7g/index.md':
        return '/blog/emergency-nurses-day-custom-lapel-pins/';
    case '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp':
        return '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best/';
    case '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp/index':
        return '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best/';
    case '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best-ngbm4kg8ldtp/index.md':
        return '/blog/employee-appreciation-day-custom-lapel-pins-bring-out-your-workers-best/';
    case '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm':
        return '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace/';
    case '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm/index':
        return '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace/';
    case '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace-ngbm1i3h08lm/index.md':
        return '/blog/employee-appreciation-day-custom-lapel-pins-for-your-workplace/';
    case '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv':
        return '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins/';
    case '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv/index':
        return '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins/';
    case '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins-ngbm69k5e5hv/index.md':
        return '/blog/empowering-literacy-champions-the-role-of-challenge-coins-in-the-everglades-foundation-with-custom-challenge-coins/';
    case '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t':
        return '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift/';
    case '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t/index':
        return '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift/';
    case '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift-ngbm1t9rnt4t/index.md':
        return '/blog/encourage-happiness-in-your-schools-with-a-custom-lapel-pin-gift/';
    case '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc':
        return '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins/';
    case '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc/index':
        return '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins/';
    case '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins-ngbm5vsmythc/index.md':
        return '/blog/exploring-the-power-and-artistry-of-flag-pins-and-political-enamel-pins/';
    case '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj':
        return '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes/';
    case '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj/index':
        return '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes/';
    case '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes-ngbm4y07j3aj/index.md':
        return '/blog/exxonmobil-creates-custom-lapel-pins-for-branding-purposes/';
    case '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi':
        return '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive/';
    case '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi/index':
        return '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive/';
    case '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive-ngbm34eoyzbi/index.md':
        return '/blog/family-reunion-custom-lapel-pins-are-great-for-keeping-memories-alive/';
    case '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz':
        return '/blog/finding-the-best-custom-pin-manufacturer/';
    case '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz/index':
        return '/blog/finding-the-best-custom-pin-manufacturer/';
    case '/blog/finding-the-best-custom-pin-manufacturer-ngbm1lcbelxz/index.md':
        return '/blog/finding-the-best-custom-pin-manufacturer/';
    case '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3':
        return '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins/';
    case '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3/index':
        return '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins/';
    case '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins-ngbm8qldtst3/index.md':
        return '/blog/finnegan-aviation-warbirds-and-american-made-challenge-coins/';
    case '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba':
        return '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants/';
    case '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba/index':
        return '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants/';
    case '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants-ngbm3j2zihba/index.md':
        return '/blog/fleetwood-rv-provides-custom-lapel-pins-to-national-rally-participants/';
    case '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd':
        return '/blog/ford-motor-credit-warrior-circle-lapel-pins/';
    case '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd/index':
        return '/blog/ford-motor-credit-warrior-circle-lapel-pins/';
    case '/blog/ford-motor-credit-warrior-circle-lapel-pins-ngbm32952asd/index.md':
        return '/blog/ford-motor-credit-warrior-circle-lapel-pins/';
    case '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y':
        return '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches/';
    case '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y/index':
        return '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches/';
    case '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches-ngbm3aro5k2y/index.md':
        return '/blog/four-ways-that-custom-lapel-pins-are-used-in-churches/';
    case '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5':
        return '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations/';
    case '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5/index':
        return '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations/';
    case '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations-ngbm4zepwnu5/index.md':
        return '/blog/four-ways-that-custom-lapel-pins-help-foundations-and-non-profit-organizations/';
    case '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy':
        return '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year/';
    case '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy/index':
        return '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year/';
    case '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year-ngbm6vf36zjy/index.md':
        return '/blog/frightfully-fun-collectibles-halloween-enamel-pins-to-watch-out-for-this-year/';
    case '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4':
        return '/blog/from-childhood-memories-to-pin-trading-passion/';
    case '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4/index':
        return '/blog/from-childhood-memories-to-pin-trading-passion/';
    case '/blog/from-childhood-memories-to-pin-trading-passion-ngdh1qa8l9p4/index.md':
        return '/blog/from-childhood-memories-to-pin-trading-passion/';
    case '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk':
        return '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace/';
    case '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk/index':
        return '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace/';
    case '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace-ngbm54xffixk/index.md':
        return '/blog/from-corporate-to-creative-lapel-pins-in-the-modern-workplace/';
    case '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj':
        return '/blog/gaining-community-support-through-custom-fundraising-lapel-pins/';
    case '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj/index':
        return '/blog/gaining-community-support-through-custom-fundraising-lapel-pins/';
    case '/blog/gaining-community-support-through-custom-fundraising-lapel-pins-ngbm1c605ihj/index.md':
        return '/blog/gaining-community-support-through-custom-fundraising-lapel-pins/';
    case '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo':
        return '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins/';
    case '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo/index':
        return '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins/';
    case '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins-ngbm43yeykxo/index.md':
        return '/blog/game-studio-awards-employees-with-length-of-service-challenge-coins/';
    case '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x':
        return '/blog/gamesa-challenge-coin-awards/';
    case '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x/index':
        return '/blog/gamesa-challenge-coin-awards/';
    case '/blog/gamesa-challenge-coin-awards-ngbm3txcg45x/index.md':
        return '/blog/gamesa-challenge-coin-awards/';
    case '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd':
        return '/blog/gcmeyers-custom-challenge-coin/';
    case '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd/index':
        return '/blog/gcmeyers-custom-challenge-coin/';
    case '/blog/gcmeyers-custom-challenge-coin-ngbm8fkkfcnd/index.md':
        return '/blog/gcmeyers-custom-challenge-coin/';
    case '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5':
        return '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins/';
    case '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5/index':
        return '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins/';
    case '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins-ngbm2r4e7bn5/index.md':
        return '/blog/generate-your-own-qr-codes-for-your-custom-lapel-pins-and-challenge-coins/';
    case '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a':
        return '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year/';
    case '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a/index':
        return '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year/';
    case '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year-ngbm043scs0a/index.md':
        return '/blog/get-ahead-of-the-game-restock-your-enamel-pin-shop-for-the-new-year/';
    case '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4':
        return '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins/';
    case '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4/index':
        return '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins/';
    case '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins-ngbm2najlnr4/index.md':
        return '/blog/getting-the-word-out-about-your-business-with-custom-lapel-pins/';
    case '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k':
        return '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift/';
    case '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k/index':
        return '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift/';
    case '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift-ngbm1e3s6k6k/index.md':
        return '/blog/give-people-who-take-your-challenge-a-custom-lapel-pin-gift/';
    case '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y':
        return '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries/';
    case '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y/index':
        return '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries/';
    case '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries-ngbm62jm1a3y/index.md':
        return '/blog/giving-thanks-to-the-linesman-linesman-appreciation-day-with-high-voltage-industries/';
    case '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3':
        return '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins/';
    case '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3/index':
        return '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins/';
    case '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins-ngbm2bgle0t3/index.md':
        return '/blog/golf-channel-guests-and-vips-receive-custom-collectible-trading-lapel-pins/';
    case '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2':
        return '/blog/golf-pins-are-perfect-for-your-organized-event/';
    case '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2/index':
        return '/blog/golf-pins-are-perfect-for-your-organized-event/';
    case '/blog/golf-pins-are-perfect-for-your-organized-event-ngbm39agn3z2/index.md':
        return '/blog/golf-pins-are-perfect-for-your-organized-event/';
    case '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85':
        return '/blog/guide-to-pricing-custom-enamel-pins-for-retail/';
    case '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85/index':
        return '/blog/guide-to-pricing-custom-enamel-pins-for-retail/';
    case '/blog/guide-to-pricing-custom-enamel-pins-for-retail-ngbm10tfzm85/index.md':
        return '/blog/guide-to-pricing-custom-enamel-pins-for-retail/';
    case '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r':
        return '/blog/guinness-custom-veteran-coin/';
    case '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r/index':
        return '/blog/guinness-custom-veteran-coin/';
    case '/blog/guinness-custom-veteran-coin-ngbm7zk8gc8r/index.md':
        return '/blog/guinness-custom-veteran-coin/';
    case '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm':
        return '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins/';
    case '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm/index':
        return '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins/';
    case '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins-ngbm3r61j7jm/index.md':
        return '/blog/health-awareness-issues-are-addressed-with-custom-lapel-pins/';
    case '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7':
        return '/help/what-are-your-lapel-pins-made-from/';
    case '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7/index':
        return '/help/what-are-your-lapel-pins-made-from/';
    case '/blog/help/what-are-your-lapel-pins-made-from-ngbm5h983lg7/index.md':
        return '/help/what-are-your-lapel-pins-made-from/';
    case '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf':
        return '/help/what-metal-plating-options-do-you-offer/';
    case '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf/index':
        return '/help/what-metal-plating-options-do-you-offer/';
    case '/blog/help/what-metal-plating-options-do-you-offer-ngbm5h9wshuf/index.md':
        return '/help/what-metal-plating-options-do-you-offer/';
    case '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6':
        return '/help/why-are-my-pins-destined-for-an-apo-address/';
    case '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6/index':
        return '/help/why-are-my-pins-destined-for-an-apo-address/';
    case '/blog/help/why-are-my-pins-destined-for-an-apo-address-ngbm5jk8ieu6/index.md':
        return '/help/why-are-my-pins-destined-for-an-apo-address/';
    case '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd':
        return '/blog/hockey-pins-for-your-sports-team/';
    case '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd/index':
        return '/blog/hockey-pins-for-your-sports-team/';
    case '/blog/hockey-pins-for-your-sports-team-ngbm18qf9axd/index.md':
        return '/blog/hockey-pins-for-your-sports-team/';
    case '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw':
        return '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins/';
    case '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw/index':
        return '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins/';
    case '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins-ngbm35xedvbw/index.md':
        return '/blog/honoring-fallen-veterans-of-pearl-harbor-with-remembrance-lapel-pins/';
    case '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl':
        return '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition/';
    case '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl/index':
        return '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition/';
    case '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition-ngbm8nn940rl/index.md':
        return '/blog/how-guinness-continues-the-old-school-challenge-coin-tradition/';
    case '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4':
        return '/blog/how-many-trading-pins-should-i-buy/';
    case '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4/index':
        return '/blog/how-many-trading-pins-should-i-buy/';
    case '/blog/how-many-trading-pins-should-i-buy-ngbm3xyn02l4/index.md':
        return '/blog/how-many-trading-pins-should-i-buy/';
    case '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw':
        return '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements/';
    case '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw/index':
        return '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements/';
    case '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements-ngbm571grksw/index.md':
        return '/blog/how-soft-enamel-pins-are-redefining-advocacy-and-social-movements/';
    case '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys':
        return '/blog/how-the-chinese-new-year-affects-our-schedule/';
    case '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys/index':
        return '/blog/how-the-chinese-new-year-affects-our-schedule/';
    case '/blog/how-the-chinese-new-year-affects-our-schedule-ngbm2ivqmoys/index.md':
        return '/blog/how-the-chinese-new-year-affects-our-schedule/';
    case '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e':
        return '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins/';
    case '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e/index':
        return '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins/';
    case '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins-ngbm1km8ix9e/index.md':
        return '/blog/how-to-complete-the-online-order-form-for-custom-challenge-coins/';
    case '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz':
        return '/blog/how-to-create-custom-hockey-trading-pins-for-your-team/';
    case '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz/index':
        return '/blog/how-to-create-custom-hockey-trading-pins-for-your-team/';
    case '/blog/how-to-create-custom-hockey-trading-pins-for-your-team-nhn63806bvdz/index.md':
        return '/blog/how-to-create-custom-hockey-trading-pins-for-your-team/';
    case '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial':
        return '/blog/how-to-start-your-own-enamel-pin-packs/';
    case '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial/index':
        return '/blog/how-to-start-your-own-enamel-pin-packs/';
    case '/blog/how-to-start-your-own-enamel-pin-packs-ngbm5ktu9ial/index.md':
        return '/blog/how-to-start-your-own-enamel-pin-packs/';
    case '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4':
        return '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients/';
    case '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4/index':
        return '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients/';
    case '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients-ngbm2u3hguc4/index.md':
        return '/blog/iata-headquarters-has-custom-lapel-pins-made-for-its-employees-and-award-recipients/';
    case '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d':
        return '/blog/insert-cards-for-your-challenge-coin-order/';
    case '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d/index':
        return '/blog/insert-cards-for-your-challenge-coin-order/';
    case '/blog/insert-cards-for-your-challenge-coin-order-ngbm5burhr5d/index.md':
        return '/blog/insert-cards-for-your-challenge-coin-order/';
    case '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn':
        return '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins/';
    case '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn/index':
        return '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins/';
    case '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins-ngbm52nsblpn/index.md':
        return '/blog/inspiring-employee-appreciation-carls-jr-nationwide-competition-rewards-with-custom-lapel-pins/';
    case '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n':
        return '/blog/its-never-too-early-for-baseball-pins/';
    case '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n/index':
        return '/blog/its-never-too-early-for-baseball-pins/';
    case '/blog/its-never-too-early-for-baseball-pins-ngbm3cn5s40n/index.md':
        return '/blog/its-never-too-early-for-baseball-pins/';
    case '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9':
        return '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers/';
    case '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9/index':
        return '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers/';
    case '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers-ngbm2o44yla9/index.md':
        return '/blog/jacks-creates-custom-award-lapel-pins-for-its-managers/';
    case '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx':
        return '/blog/kpb-designs-from-watercolor-to-lapel-pin/';
    case '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx/index':
        return '/blog/kpb-designs-from-watercolor-to-lapel-pin/';
    case '/blog/kpb-designs-from-watercolor-to-lapel-pin-njax8b96mcpx/index.md':
        return '/blog/kpb-designs-from-watercolor-to-lapel-pin/';
    case '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d':
        return '/blog/lapel-pins-forged-for-the-gods-of-smite/';
    case '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d/index':
        return '/blog/lapel-pins-forged-for-the-gods-of-smite/';
    case '/blog/lapel-pins-forged-for-the-gods-of-smite-ngj7fru0440d/index.md':
        return '/blog/lapel-pins-forged-for-the-gods-of-smite/';
    case '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd':
        return '/blog/little-league-baseball-pins-from-traditional-to-trending/';
    case '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd/index':
        return '/blog/little-league-baseball-pins-from-traditional-to-trending/';
    case '/blog/little-league-baseball-pins-from-traditional-to-trending-ngbm04xsahvd/index.md':
        return '/blog/little-league-baseball-pins-from-traditional-to-trending/';
    case '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9':
        return '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city/';
    case '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9/index':
        return '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city/';
    case '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city-ngbm42h0jdm9/index.md':
        return '/blog/los-angeles-challenge-coins-offer-diverse-viewpoints-of-the-city/';
    case '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf':
        return '/blog/lost-challenge-coin-reunited-with-grateful-owner/';
    case '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf/index':
        return '/blog/lost-challenge-coin-reunited-with-grateful-owner/';
    case '/blog/lost-challenge-coin-reunited-with-grateful-owner-ngbm3ntaguzf/index.md':
        return '/blog/lost-challenge-coin-reunited-with-grateful-owner/';
    case '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g':
        return '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals/';
    case '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g/index':
        return '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals/';
    case '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals-ngbm15i83o2g/index.md':
        return '/blog/mac-tools-challenge-coins-promote-and-reinforce-company-goals/';
    case '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg':
        return '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option/';
    case '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg/index':
        return '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option/';
    case '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option-nhvszk70jrhg/index.md':
        return '/blog/make-your-pins-pop-a-guide-to-choosing-the-best-plating-option/';
    case '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn':
        return '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization/';
    case '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn/index':
        return '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization/';
    case '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization-ngbm25chethn/index.md':
        return '/blog/mariahs-challenge-lapel-pins-bring-attention-to-a-worthy-organization/';
    case '/blog/masonic-challenge-coins-nh42qr2j6vfw':
        return '/blog/masonic-challenge-coins/';
    case '/blog/masonic-challenge-coins-nh42qr2j6vfw/index':
        return '/blog/masonic-challenge-coins/';
    case '/blog/masonic-challenge-coins-nh42qr2j6vfw/index.md':
        return '/blog/masonic-challenge-coins/';
    case '/blog/meme-enamel-pins-ngbm1ahco7dm':
        return '/blog/meme-enamel-pins/';
    case '/blog/meme-enamel-pins-ngbm1ahco7dm/index':
        return '/blog/meme-enamel-pins/';
    case '/blog/meme-enamel-pins-ngbm1ahco7dm/index.md':
        return '/blog/meme-enamel-pins/';
    case '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j':
        return '/military-challenge-coins/custom-airforce-challenge-coins/';
    case '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j/index':
        return '/military-challenge-coins/custom-airforce-challenge-coins/';
    case '/blog/military-challenge-coins/custom-airforce-challenge-coins-ngbm7gb4d70j/index.md':
        return '/military-challenge-coins/custom-airforce-challenge-coins/';
    case '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b':
        return '/military-challenge-coins/custom-army-challenge-coins/';
    case '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b/index':
        return '/military-challenge-coins/custom-army-challenge-coins/';
    case '/blog/military-challenge-coins/custom-army-challenge-coins-ngbm7b7c8c1b/index.md':
        return '/military-challenge-coins/custom-army-challenge-coins/';
    case '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395':
        return '/military-challenge-coins/custom-navy-challenge-coins/';
    case '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395/index':
        return '/military-challenge-coins/custom-navy-challenge-coins/';
    case '/blog/military-challenge-coins/custom-navy-challenge-coins-ngbm7cpsg395/index.md':
        return '/military-challenge-coins/custom-navy-challenge-coins/';
    case '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59':
        return '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins/';
    case '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59/index':
        return '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins/';
    case '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins-ngbm27nzoy59/index.md':
        return '/blog/mma-students-of-relson-gracie-academia-de-jiu-jitsu-receive-custom-challenge-coins/';
    case '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq':
        return '/blog/motorcycle-lapel-pins-to-prevent-child-abuse/';
    case '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq/index':
        return '/blog/motorcycle-lapel-pins-to-prevent-child-abuse/';
    case '/blog/motorcycle-lapel-pins-to-prevent-child-abuse-ngbm2kw7vriq/index.md':
        return '/blog/motorcycle-lapel-pins-to-prevent-child-abuse/';
    case '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2':
        return '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days/';
    case '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2/index':
        return '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days/';
    case '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days-ng5fc58grnl2/index.md':
        return '/blog/mrbeast-putting-the-challenge-back-in-challenge-coins-how-we-made-coins-for-the-beast-games-in-just-6-days/';
    case '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f':
        return '/blog/multi-product-orders-for-custom-pins-patches-and-coins/';
    case '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f/index':
        return '/blog/multi-product-orders-for-custom-pins-patches-and-coins/';
    case '/blog/multi-product-orders-for-custom-pins-patches-and-coins-ngbm1masut1f/index.md':
        return '/blog/multi-product-orders-for-custom-pins-patches-and-coins/';
    case '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t':
        return '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins/';
    case '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t/index':
        return '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins/';
    case '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins-ngbm4dw3ng5t/index.md':
        return '/blog/nasas-osiris-rex-asteroid-satellite-with-university-of-arizona-custom-lapel-pins/';
    case '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx':
        return '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa/';
    case '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx/index':
        return '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa/';
    case '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa-ngbm2jq5fhxx/index.md':
        return '/blog/nashville-tennessee-lapel-pins-highlight-the-country-music-capital-of-the-usa/';
    case '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3':
        return '/blog/national-camping-month-custom-lapel-pins-promote-your-campground/';
    case '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3/index':
        return '/blog/national-camping-month-custom-lapel-pins-promote-your-campground/';
    case '/blog/national-camping-month-custom-lapel-pins-promote-your-campground-ngbm28iakvo3/index.md':
        return '/blog/national-camping-month-custom-lapel-pins-promote-your-campground/';
    case '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o':
        return '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork/';
    case '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o/index':
        return '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork/';
    case '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork-ngbm1h7xde6o/index.md':
        return '/blog/national-craft-month-custom-lapel-pins-promote-your-handiwork/';
    case '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c':
        return '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month/';
    case '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c/index':
        return '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month/';
    case '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month-ngbm37itad9c/index.md':
        return '/blog/national-cyber-security-alliance-creates-custom-lapel-pin-for-national-cyber-security-awareness-month/';
    case '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x':
        return '/blog/national-stop-bullying-day-custom-lapel-pins/';
    case '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x/index':
        return '/blog/national-stop-bullying-day-custom-lapel-pins/';
    case '/blog/national-stop-bullying-day-custom-lapel-pins-ngbm23hla48x/index.md':
        return '/blog/national-stop-bullying-day-custom-lapel-pins/';
    case '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd':
        return '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness/';
    case '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd/index':
        return '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness/';
    case '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness-ngbm2dwm29kd/index.md':
        return '/blog/national-stop-bullying-day-custom-lapel-pins-raise-awareness/';
    case '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz':
        return '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today/';
    case '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz/index':
        return '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today/';
    case '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today-ngbm3iwvbrmz/index.md':
        return '/blog/need-challenge-coins-fast-call-all-about-challenge-coins-today/';
    case '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny':
        return '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins/';
    case '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny/index':
        return '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins/';
    case '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins-ngbm23r5q1ny/index.md':
        return '/blog/octobers-breast-cancer-awareness-month-motorcycle-run-lapel-pins/';
    case '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49':
        return '/blog/offering-a-helping-hand-with-veteran-challenge-coins/';
    case '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49/index':
        return '/blog/offering-a-helping-hand-with-veteran-challenge-coins/';
    case '/blog/offering-a-helping-hand-with-veteran-challenge-coins-njaq81kd9g49/index.md':
        return '/blog/offering-a-helping-hand-with-veteran-challenge-coins/';
    case '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2':
        return '/blog/optimizing-artwork-for-custom-lapel-pins/';
    case '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2/index':
        return '/blog/optimizing-artwork-for-custom-lapel-pins/';
    case '/blog/optimizing-artwork-for-custom-lapel-pins-ngbm1cfkwdn2/index.md':
        return '/blog/optimizing-artwork-for-custom-lapel-pins/';
    case '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll':
        return '/blog/ordering-custom-challenge-coins-on-a-budget/';
    case '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll/index':
        return '/blog/ordering-custom-challenge-coins-on-a-budget/';
    case '/blog/ordering-custom-challenge-coins-on-a-budget-ngbm664z48ll/index.md':
        return '/blog/ordering-custom-challenge-coins-on-a-budget/';
    case '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg':
        return '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010/';
    case '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg/index':
        return '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010/';
    case '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010-ngbm2yfuo5pg/index.md':
        return '/blog/ordering-fathers-day-lapel-pins-for-june-20th-2010/';
    case '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1':
        return '/blog/orlando-magic-custom-challenge-coins/';
    case '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1/index':
        return '/blog/orlando-magic-custom-challenge-coins/';
    case '/blog/orlando-magic-custom-challenge-coins-ngbm7xzax4n1/index.md':
        return '/blog/orlando-magic-custom-challenge-coins/';
    case '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl':
        return '/blog/our-holiday-schedule-and-holiday-wishes-for-you/';
    case '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl/index':
        return '/blog/our-holiday-schedule-and-holiday-wishes-for-you/';
    case '/blog/our-holiday-schedule-and-holiday-wishes-for-you-ngbm40hhh3kl/index.md':
        return '/blog/our-holiday-schedule-and-holiday-wishes-for-you/';
    case '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu':
        return '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet/';
    case '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu/index':
        return '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet/';
    case '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet-ngbm19o2mwqu/index.md':
        return '/blog/our-suggestions-for-designing-your-best-custom-trading-lapel-pins-yet/';
    case '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s':
        return '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins/';
    case '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s/index':
        return '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins/';
    case '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins-ngbm2081s48s/index.md':
        return '/blog/outstanding-food-and-beverage-staff-are-awarded-with-custom-employee-award-lapel-pins/';
    case '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj':
        return '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality/';
    case '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj/index':
        return '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality/';
    case '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality-ngbm4r66ekqj/index.md':
        return '/blog/pantone-color-matching-system-helps-give-your-promotional-products-personality/';
    case '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx':
        return '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins/';
    case '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx/index':
        return '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins/';
    case '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins-ngbm45du9djx/index.md':
        return '/blog/participants-of-33rd-british-motorcycle-meet-receive-customized-event-lapel-pins/';
    case '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6':
        return '/blog/patriotic-lapel-pins-make-every-day-veterans-day/';
    case '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6/index':
        return '/blog/patriotic-lapel-pins-make-every-day-veterans-day/';
    case '/blog/patriotic-lapel-pins-make-every-day-veterans-day-ngbm2ey1h1f6/index.md':
        return '/blog/patriotic-lapel-pins-make-every-day-veterans-day/';
    case '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw':
        return '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others/';
    case '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw/index':
        return '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others/';
    case '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others-ngbm3qh879mw/index.md':
        return '/blog/people-to-people-china-creates-custom-lapel-pins-to-exchange-with-others/';
    case '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic':
        return '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards/';
    case '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic/index':
        return '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards/';
    case '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards-ngbm3yzc2sic/index.md':
        return '/blog/perfect-attendance-award-pins-can-be-worn-or-attached-to-bags-or-lanyards/';
    case '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz':
        return '/blog/personalizing-custom-lapel-pins-with-backstamps/';
    case '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz/index':
        return '/blog/personalizing-custom-lapel-pins-with-backstamps/';
    case '/blog/personalizing-custom-lapel-pins-with-backstamps-ngbm1fwuu0vz/index.md':
        return '/blog/personalizing-custom-lapel-pins-with-backstamps/';
    case '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66':
        return '/blog/personalizing-employee-welcome-kits-with-custom-pins/';
    case '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66/index':
        return '/blog/personalizing-employee-welcome-kits-with-custom-pins/';
    case '/blog/personalizing-employee-welcome-kits-with-custom-pins-ngbm1vbadx66/index.md':
        return '/blog/personalizing-employee-welcome-kits-with-custom-pins/';
    case '/blog/pin-types-soft-enamel-ngbm2q29wlph':
        return '/blog/pin-types-soft-enamel/';
    case '/blog/pin-types-soft-enamel-ngbm2q29wlph/index':
        return '/blog/pin-types-soft-enamel/';
    case '/blog/pin-types-soft-enamel-ngbm2q29wlph/index.md':
        return '/blog/pin-types-soft-enamel/';
    case '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx':
        return '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands/';
    case '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx/index':
        return '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands/';
    case '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands-ngbm08r3gubx/index.md':
        return '/blog/pinning-down-your-brands-success-a-guide-to-custom-pins-for-apparel-brands/';
    case '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln':
        return '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene/';
    case '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln/index':
        return '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene/';
    case '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene-ngbm6xjnnhln/index.md':
        return '/blog/pins-and-brews-how-custom-lapel-pins-are-taking-over-the-brewery-merch-scene/';
    case '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07':
        return '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed/';
    case '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07/index':
        return '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed/';
    case '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed-ngbm1ft0tb07/index.md':
        return '/blog/planning-a-trip-to-south-carolina-make-sure-you-have-plenty-of-these-packed/';
    case '/blog/political-party-pins-ngbm4r6vhw37':
        return '/blog/political-party-pins/';
    case '/blog/political-party-pins-ngbm4r6vhw37/index':
        return '/blog/political-party-pins/';
    case '/blog/political-party-pins-ngbm4r6vhw37/index.md':
        return '/blog/political-party-pins/';
    case '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7':
        return '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins/';
    case '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7/index':
        return '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins/';
    case '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins-ngbm16nxpln7/index.md':
        return '/blog/porsche-clubs-across-the-world-love-custom-lapel-pins/';
    case '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4':
        return '/blog/preparing-custom-pins-for-retail/';
    case '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4/index':
        return '/blog/preparing-custom-pins-for-retail/';
    case '/blog/preparing-custom-pins-for-retail-ngbm1q9jfug4/index.md':
        return '/blog/preparing-custom-pins-for-retail/';
    case '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag':
        return '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host/';
    case '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag/index':
        return '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host/';
    case '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host-ngbm2dwdfdag/index.md':
        return '/blog/price-is-right-challenge-coins-welcome-drew-carey-as-a-host/';
    case '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9':
        return '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons/';
    case '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9/index':
        return '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons/';
    case '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons-ngbm1goh7zl9/index.md':
        return '/blog/promote-national-karaoke-week-with-custom-lapel-pins-for-patrons/';
    case '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj':
        return '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins/';
    case '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj/index':
        return '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins/';
    case '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins-ngbm4mpq9vdj/index.md':
        return '/blog/promote-your-comedy-club-during-national-humor-month-with-custom-lapel-pins/';
    case '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho':
        return '/blog/promote-your-software-development-company-with-custom-lapel-pins/';
    case '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho/index':
        return '/blog/promote-your-software-development-company-with-custom-lapel-pins/';
    case '/blog/promote-your-software-development-company-with-custom-lapel-pins-ngbm2w8brkho/index.md':
        return '/blog/promote-your-software-development-company-with-custom-lapel-pins/';
    case '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh':
        return '/blog/promoting-your-new-business-with-custom-lapel-pins/';
    case '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh/index':
        return '/blog/promoting-your-new-business-with-custom-lapel-pins/';
    case '/blog/promoting-your-new-business-with-custom-lapel-pins-ngbm31u6dnlh/index.md':
        return '/blog/promoting-your-new-business-with-custom-lapel-pins/';
    case '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l':
        return '/blog/ptsd-challenge-coins-and-one-authors-incredible-story/';
    case '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l/index':
        return '/blog/ptsd-challenge-coins-and-one-authors-incredible-story/';
    case '/blog/ptsd-challenge-coins-and-one-authors-incredible-story-ngbm645zcd6l/index.md':
        return '/blog/ptsd-challenge-coins-and-one-authors-incredible-story/';
    case '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9':
        return '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins/';
    case '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9/index':
        return '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins/';
    case '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins-ngbm2wcctwp9/index.md':
        return '/blog/published-authors-can-create-interest-in-their-books-with-custom-challenge-coins/';
    case '/blog/quilters-custom-pins-ngbm6ps4psc9':
        return '/blog/quilters-custom-pins/';
    case '/blog/quilters-custom-pins-ngbm6ps4psc9/index':
        return '/blog/quilters-custom-pins/';
    case '/blog/quilters-custom-pins-ngbm6ps4psc9/index.md':
        return '/blog/quilters-custom-pins/';
    case '/blog/radio-station-lapel-pins-ngbm4lltppa5':
        return '/blog/radio-station-lapel-pins/';
    case '/blog/radio-station-lapel-pins-ngbm4lltppa5/index':
        return '/blog/radio-station-lapel-pins/';
    case '/blog/radio-station-lapel-pins-ngbm4lltppa5/index.md':
        return '/blog/radio-station-lapel-pins/';
    case '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i':
        return '/blog/recognition-lapel-pins-take-employees-to-their-next-level/';
    case '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i/index':
        return '/blog/recognition-lapel-pins-take-employees-to-their-next-level/';
    case '/blog/recognition-lapel-pins-take-employees-to-their-next-level-ngbm3r6qfb9i/index.md':
        return '/blog/recognition-lapel-pins-take-employees-to-their-next-level/';
    case '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w':
        return '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics/';
    case '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w/index':
        return '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics/';
    case '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics-ngbm6s96hm4w/index.md':
        return '/blog/revisiting-the-custom-trading-pin-craze-of-the-2024-olympics/';
    case '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3':
        return '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses/';
    case '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3/index':
        return '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses/';
    case '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses-ngbm55r2mkc3/index.md':
        return '/blog/rush-pins-across-industries-meeting-quick-turnaround-demands-for-various-uses/';
    case '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap':
        return '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins/';
    case '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap/index':
        return '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins/';
    case '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins-ngbm17oftnap/index.md':
        return '/blog/scott-air-force-base-awards-the-outstanding-airmen-of-the-year-with-custom-military-challenge-coins/';
    case '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi':
        return '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel/';
    case '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi/index':
        return '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel/';
    case '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel-ngbm1swphffi/index.md':
        return '/blog/selling-custom-lapel-pins-choosing-an-online-sales-channel/';
    case '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw':
        return '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events/';
    case '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw/index':
        return '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events/';
    case '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events-ngbm20xn5icw/index.md':
        return '/blog/september-was-national-preparedness-month-and-many-groups-use-lapel-pins-to-promote-their-events/';
    case '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3':
        return '/blog/soaring-in-style-custom-pins-take-flight/';
    case '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3/index':
        return '/blog/soaring-in-style-custom-pins-take-flight/';
    case '/blog/soaring-in-style-custom-pins-take-flight-njbl71no53u3/index.md':
        return '/blog/soaring-in-style-custom-pins-take-flight/';
    case '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8':
        return '/blog/sports-car-club-of-america-custom-embroidered-patches/';
    case '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8/index':
        return '/blog/sports-car-club-of-america-custom-embroidered-patches/';
    case '/blog/sports-car-club-of-america-custom-embroidered-patches-ngbm2thiiko8/index.md':
        return '/blog/sports-car-club-of-america-custom-embroidered-patches/';
    case '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3':
        return '/blog/stake-your-claim-with-a-custom-backstamp/';
    case '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3/index':
        return '/blog/stake-your-claim-with-a-custom-backstamp/';
    case '/blog/stake-your-claim-with-a-custom-backstamp-ngbm1wnry2t3/index.md':
        return '/blog/stake-your-claim-with-a-custom-backstamp/';
    case '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62':
        return '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success/';
    case '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62/index':
        return '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success/';
    case '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success-ngbm4w905b62/index.md':
        return '/blog/stanford-university-medical-school-lapel-pins-are-a-big-success/';
    case '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y':
        return '/blog/stomp-out-bullying-with-custom-lapel-pins/';
    case '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y/index':
        return '/blog/stomp-out-bullying-with-custom-lapel-pins/';
    case '/blog/stomp-out-bullying-with-custom-lapel-pins-ngbm3k4pfv9y/index.md':
        return '/blog/stomp-out-bullying-with-custom-lapel-pins/';
    case '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2':
        return '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts/';
    case '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2/index':
        return '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts/';
    case '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts-ngbm2clii6g2/index.md':
        return '/blog/sts-133-space-shuttle-discovery-challenge-coins-commemorate-astronauts/';
    case '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9':
        return '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins/';
    case '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9/index':
        return '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins/';
    case '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins-ngbm1c9sues9/index.md':
        return '/blog/support-your-colleges-vinyl-spinning-club-with-custom-lapel-pins/';
    case '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq':
        return '/blog/taking-your-design-and-making-it-pop/';
    case '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq/index':
        return '/blog/taking-your-design-and-making-it-pop/';
    case '/blog/taking-your-design-and-making-it-pop-ngbm1q328idq/index.md':
        return '/blog/taking-your-design-and-making-it-pop/';
    case '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs':
        return '/blog/teacher-and-school-staff-lapel-pins/';
    case '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs/index':
        return '/blog/teacher-and-school-staff-lapel-pins/';
    case '/blog/teacher-and-school-staff-lapel-pins-ngbm11rhexvs/index.md':
        return '/blog/teacher-and-school-staff-lapel-pins/';
    case '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn':
        return '/blog/teacher-appreciation-week-custom-lapel-pins/';
    case '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn/index':
        return '/blog/teacher-appreciation-week-custom-lapel-pins/';
    case '/blog/teacher-appreciation-week-custom-lapel-pins-ngbm2ezbh9qn/index.md':
        return '/blog/teacher-appreciation-week-custom-lapel-pins/';
    case '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y':
        return '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day/';
    case '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y/index':
        return '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day/';
    case '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day-ngbm4jdcq90y/index.md':
        return '/blog/the-all-about-network-wants-you-to-have-a-safe-memorial-day/';
    case '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z':
        return '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins/';
    case '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z/index':
        return '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins/';
    case '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins-nhjten8gau8z/index.md':
        return '/blog/the-benefits-of-using-silkscreen-on-your-custom-lapel-pins/';
    case '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n':
        return '/blog/the-evolution-of-cloissone-pins/';
    case '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n/index':
        return '/blog/the-evolution-of-cloissone-pins/';
    case '/blog/the-evolution-of-cloissone-pins-ngbm6h3jkz8n/index.md':
        return '/blog/the-evolution-of-cloissone-pins/';
    case '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476':
        return '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries/';
    case '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476/index':
        return '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries/';
    case '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries-ngbm3wnua476/index.md':
        return '/blog/the-great-american-motorcycle-adventure-lapel-pins-overstep-boundaries/';
    case '/blog/the-history-of-challenge-coins-ngbm35js8lz9':
        return '/blog/the-history-of-challenge-coins/';
    case '/blog/the-history-of-challenge-coins-ngbm35js8lz9/index':
        return '/blog/the-history-of-challenge-coins/';
    case '/blog/the-history-of-challenge-coins-ngbm35js8lz9/index.md':
        return '/blog/the-history-of-challenge-coins/';
    case '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd':
        return '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide/';
    case '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd/index':
        return '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide/';
    case '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide-ngbm18ignbzd/index.md':
        return '/blog/the-many-uses-of-lapel-pins-in-schools-and-universities-worldwide/';
    case '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc':
        return '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out/';
    case '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc/index':
        return '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out/';
    case '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out-ngbm6fadmrkc/index.md':
        return '/blog/the-personal-touch-how-to-make-your-custom-lapel-pins-stand-out/';
    case '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86':
        return '/blog/the-power-of-custom-family-reunion-pins/';
    case '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86/index':
        return '/blog/the-power-of-custom-family-reunion-pins/';
    case '/blog/the-power-of-custom-family-reunion-pins-ngbm5nwfqg86/index.md':
        return '/blog/the-power-of-custom-family-reunion-pins/';
    case '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8':
        return '/blog/the-rise-of-american-made-challenge-coins/';
    case '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8/index':
        return '/blog/the-rise-of-american-made-challenge-coins/';
    case '/blog/the-rise-of-american-made-challenge-coins-ngbm8s5zgyf8/index.md':
        return '/blog/the-rise-of-american-made-challenge-coins/';
    case '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr':
        return '/blog/the-ultimate-guide-to-trading-pin-upgrades/';
    case '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr/index':
        return '/blog/the-ultimate-guide-to-trading-pin-upgrades/';
    case '/blog/the-ultimate-guide-to-trading-pin-upgrades-ngbm0779wehr/index.md':
        return '/blog/the-ultimate-guide-to-trading-pin-upgrades/';
    case '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7':
        return '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel/';
    case '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7/index':
        return '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel/';
    case '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel-ngw00v531ys7/index.md':
        return '/blog/the-ultimate-ocp-patch-color-guide-for-military-personnel/';
    case '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7':
        return '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins/';
    case '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7/index':
        return '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins/';
    case '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins-ngbm3a3b6xk7/index.md':
        return '/blog/the-university-of-florida-and-shands-hospital-create-custom-awareness-ribbon-lapel-pins/';
    case '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p':
        return '/blog/tips-for-selling-custom-enamel-pins/';
    case '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p/index':
        return '/blog/tips-for-selling-custom-enamel-pins/';
    case '/blog/tips-for-selling-custom-enamel-pins-ngbm1nephf2p/index.md':
        return '/blog/tips-for-selling-custom-enamel-pins/';
    case '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj':
        return '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning/';
    case '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj/index':
        return '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning/';
    case '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning-ngbm6slt7aqj/index.md':
        return '/blog/top-5-reasons-for-using-lapel-pins-for-political-campaigning/';
    case '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr':
        return '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins/';
    case '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr/index':
        return '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins/';
    case '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins-nhb8eurmvhtr/index.md':
        return '/blog/top-5-tips-for-designing-law-enforcement-challenge-coins/';
    case '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah':
        return '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades/';
    case '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah/index':
        return '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades/';
    case '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades-ngbm10tp46ah/index.md':
        return '/blog/trading-pin-conventions-how-you-can-get-the-best-pins-in-the-fewest-trades/';
    case '/blog/trading-pin-faq-ngbm3ouo7sdl':
        return '/blog/trading-pin-faq/';
    case '/blog/trading-pin-faq-ngbm3ouo7sdl/index':
        return '/blog/trading-pin-faq/';
    case '/blog/trading-pin-faq-ngbm3ouo7sdl/index.md':
        return '/blog/trading-pin-faq/';
    case '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou':
        return '/blog/trakus-technology-lapel-pins-take-tucson-by-storm/';
    case '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou/index':
        return '/blog/trakus-technology-lapel-pins-take-tucson-by-storm/';
    case '/blog/trakus-technology-lapel-pins-take-tucson-by-storm-ngbm2gb4dlou/index.md':
        return '/blog/trakus-technology-lapel-pins-take-tucson-by-storm/';
    case '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r':
        return '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman/';
    case '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r/index':
        return '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman/';
    case '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman-ngbm8pyra92r/index.md':
        return '/blog/turtle-mania-40th-anniversary-ninja-turtle-coins-from-kevin-eastman/';
    case '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a':
        return '/blog/u-haul-celebrates-its-veterans/';
    case '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a/index':
        return '/blog/u-haul-celebrates-its-veterans/';
    case '/blog/u-haul-celebrates-its-veterans-ngbm5budkg6a/index.md':
        return '/blog/u-haul-celebrates-its-veterans/';
    case '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg':
        return '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins/';
    case '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg/index':
        return '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins/';
    case '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins-ngbm3fdxppeg/index.md':
        return '/blog/u-s-kids-golf-honors-kids-teachers-with-custom-lapel-pins/';
    case '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre':
        return '/blog/ultimate-guide-designing-creating-selling-pins/';
    case '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre/index':
        return '/blog/ultimate-guide-designing-creating-selling-pins/';
    case '/blog/ultimate-guide-designing-creating-selling-pins-ngbm6qc24sre/index.md':
        return '/blog/ultimate-guide-designing-creating-selling-pins/';
    case '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31':
        return '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins/';
    case '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31/index':
        return '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins/';
    case '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins-ngbm4b4g8j31/index.md':
        return '/blog/united-environmental-services-honors-retirees-with-custom-challenge-coins/';
    case '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9':
        return '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs/';
    case '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9/index':
        return '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs/';
    case '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs-ngbm4gtsatg9/index.md':
        return '/blog/united-way-lapel-pins-show-off-the-organizations-triumphs/';
    case '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv':
        return '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips/';
    case '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv/index':
        return '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips/';
    case '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips-ngbm5m76b3qv/index.md':
        return '/blog/unleash-your-brands-style-with-custom-hat-pins-and-brim-clips/';
    case '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8':
        return '/blog/unlv-school-of-golf-management-lapel-pins/';
    case '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8/index':
        return '/blog/unlv-school-of-golf-management-lapel-pins/';
    case '/blog/unlv-school-of-golf-management-lapel-pins-ngbm4xlvi2w8/index.md':
        return '/blog/unlv-school-of-golf-management-lapel-pins/';
    case '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30':
        return '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation/';
    case '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30/index':
        return '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation/';
    case '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation-ngbm1e1d5z30/index.md':
        return '/blog/use-custom-lapel-pins-to-encourage-people-to-plan-a-solo-vacation/';
    case '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n':
        return '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products/';
    case '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n/index':
        return '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products/';
    case '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products-ngbm22djlx7n/index.md':
        return '/blog/use-custom-lapel-pins-to-represent-and-advertise-your-products/';
    case '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd':
        return '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins/';
    case '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd/index':
        return '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins/';
    case '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins-ngbm1xrnk1bd/index.md':
        return '/blog/use-glow-in-the-dark-enamel-for-your-custom-glow-bowl-challenge-coins/';
    case '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3':
        return '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances/';
    case '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3/index':
        return '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances/';
    case '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances-ngbm34edxsh3/index.md':
        return '/blog/using-custom-lapel-pins-to-celebrate-june-holidays-and-observances/';
    case '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3':
        return '/blog/using-custom-lapel-pins-to-promote-social-distancing/';
    case '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3/index':
        return '/blog/using-custom-lapel-pins-to-promote-social-distancing/';
    case '/blog/using-custom-lapel-pins-to-promote-social-distancing-ngbm45d9vau3/index.md':
        return '/blog/using-custom-lapel-pins-to-promote-social-distancing/';
    case '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq':
        return '/blog/uss-harper-custom-coins-gator-navy/';
    case '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq/index':
        return '/blog/uss-harper-custom-coins-gator-navy/';
    case '/blog/uss-harper-custom-coins-gator-navy-ngbm7qx6vchq/index.md':
        return '/blog/uss-harper-custom-coins-gator-navy/';
    case '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e':
        return '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon/';
    case '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e/index':
        return '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon/';
    case '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon-ngbm4owqb72e/index.md':
        return '/blog/usssa-advertiser-all-about-pins-encourages-you-to-order-your-pins-soon/';
    case '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9':
        return '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence/';
    case '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9/index':
        return '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence/';
    case '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence-ngbm3qsxrbn9/index.md':
        return '/blog/verizon-creates-custom-challenge-coins-to-reward-excellence/';
    case '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod':
        return '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation/';
    case '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod/index':
        return '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation/';
    case '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation-ngbm22oyktod/index.md':
        return '/blog/verizon-uses-custom-challenge-coins-to-express-military-appreciation/';
    case '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8':
        return '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins/';
    case '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8/index':
        return '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins/';
    case '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins-ngbm4vwxcqz8/index.md':
        return '/blog/verizon-wireless-supports-first-responders-with-custom-challenge-coins/';
    case '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3':
        return '/blog/veterans-day-custom-lapel-pins/';
    case '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3/index':
        return '/blog/veterans-day-custom-lapel-pins/';
    case '/blog/veterans-day-custom-lapel-pins-ngbm48hatfo3/index.md':
        return '/blog/veterans-day-custom-lapel-pins/';
    case '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7':
        return '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles/';
    case '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7/index':
        return '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles/';
    case '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles-ngbm2p0hpqh7/index.md':
        return '/blog/video-game-manufacturers-use-challenge-coins-to-promote-new-titles/';
    case '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o':
        return '/blog/walmart-awards-with-challenge-coins/';
    case '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o/index':
        return '/blog/walmart-awards-with-challenge-coins/';
    case '/blog/walmart-awards-with-challenge-coins-ngbm3mrx8q6o/index.md':
        return '/blog/walmart-awards-with-challenge-coins/';
    case '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb':
        return '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry/';
    case '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb/index':
        return '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry/';
    case '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry-ngbm27n9mfpb/index.md':
        return '/blog/ways-that-custom-lapel-pins-recognize-repeat-customers-and-drive-business-in-the-restaurant-industry/';
    case '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l':
        return '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out/';
    case '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l/index':
        return '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out/';
    case '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out-ngbm11q7hh9l/index.md':
        return '/blog/ways-to-make-your-employee-recognition-award-lapel-pins-stand-out/';
    case '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847':
        return '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins/';
    case '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847/index':
        return '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins/';
    case '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins-ngbm29oqe847/index.md':
        return '/blog/we-love-receiving-customer-testimonials-about-our-custom-lapel-pins/';
    case '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u':
        return '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins/';
    case '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u/index':
        return '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins/';
    case '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins-ngbm4qgefs3u/index.md':
        return '/blog/we-love-receiving-testimonials-about-our-custom-lapel-pins/';
    case '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif':
        return '/blog/we-love-your-testimonials-about-our-custom-challenge-coins/';
    case '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif/index':
        return '/blog/we-love-your-testimonials-about-our-custom-challenge-coins/';
    case '/blog/we-love-your-testimonials-about-our-custom-challenge-coins-ngbm40s7seif/index.md':
        return '/blog/we-love-your-testimonials-about-our-custom-challenge-coins/';
    case '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6':
        return '/blog/what-is-the-best-plating-option-for-my-challenge-coins/';
    case '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6/index':
        return '/blog/what-is-the-best-plating-option-for-my-challenge-coins/';
    case '/blog/what-is-the-best-plating-option-for-my-challenge-coins-njap18y1vxj6/index.md':
        return '/blog/what-is-the-best-plating-option-for-my-challenge-coins/';
    case '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8':
        return '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be/';
    case '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8/index':
        return '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be/';
    case '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be-ngbm2n2199w8/index.md':
        return '/blog/what-size-should-my-customized-challenge-coins-lapel-pins-or-lanyards-be/';
    case '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz':
        return '/blog/what-type-of-pin-is-best-for-me/';
    case '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz/index':
        return '/blog/what-type-of-pin-is-best-for-me/';
    case '/blog/what-type-of-pin-is-best-for-me-ngbm1jt863oz/index.md':
        return '/blog/what-type-of-pin-is-best-for-me/';
    case '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8':
        return '/blog/why-choose-offset-printed-lapel-pins/';
    case '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8/index':
        return '/blog/why-choose-offset-printed-lapel-pins/';
    case '/blog/why-choose-offset-printed-lapel-pins-ngbm367064q8/index.md':
        return '/blog/why-choose-offset-printed-lapel-pins/';
    case '/blog/why-number-challenge-coins-ngbm46huiz8f':
        return '/blog/why-number-challenge-coins/';
    case '/blog/why-number-challenge-coins-ngbm46huiz8f/index':
        return '/blog/why-number-challenge-coins/';
    case '/blog/why-number-challenge-coins-ngbm46huiz8f/index.md':
        return '/blog/why-number-challenge-coins/';
    case '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0':
        return '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics/';
    case '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0/index':
        return '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics/';
    case '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics-ngbm4ulemcq0/index.md':
        return '/blog/wisconsin-riders-get-custom-biker-lapel-pins-to-support-the-special-olympics/';
    case '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj':
        return '/blog/years-of-service-award-lapel-pins/';
    case '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj/index':
        return '/blog/years-of-service-award-lapel-pins/';
    case '/blog/years-of-service-award-lapel-pins-ngbm4anx4cdj/index.md':
        return '/blog/years-of-service-award-lapel-pins/';
    case '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh':
        return '/blog/york-land-trust-creates-member-lapel-pins/';
    case '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh/index':
        return '/blog/york-land-trust-creates-member-lapel-pins/';
    case '/blog/york-land-trust-creates-member-lapel-pins-ngbm3o5stimh/index.md':
        return '/blog/york-land-trust-creates-member-lapel-pins/';
    case '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn':
        return '/blog/your-go-to-guide-for-national-beta-club-trading-pins/';
    case '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn/index':
        return '/blog/your-go-to-guide-for-national-beta-club-trading-pins/';
    case '/blog/your-go-to-guide-for-national-beta-club-trading-pins-ngbm6z9oiaxn/index.md':
        return '/blog/your-go-to-guide-for-national-beta-club-trading-pins/';
    case '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf':
        return '/blog/your-guide-to-crowdfunding-custom-pins/';
    case '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf/index':
        return '/blog/your-guide-to-crowdfunding-custom-pins/';
    case '/blog/your-guide-to-crowdfunding-custom-pins-ngbm1icy8mxf/index.md':
        return '/blog/your-guide-to-crowdfunding-custom-pins/';
    case '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv':
        return '/blog/your-guide-to-ordering-custom-lapel-pins/';
    case '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv/index':
        return '/blog/your-guide-to-ordering-custom-lapel-pins/';
    case '/blog/your-guide-to-ordering-custom-lapel-pins-ngbm48vtj7iv/index.md':
        return '/blog/your-guide-to-ordering-custom-lapel-pins/';
    case '/bottle-openers':
        return '/bottle-openers/';
    case '/bottle-openers/index':
        return '/bottle-openers/';
    case '/bottle-openers/index.html':
        return '/bottle-openers/';
    case '/cart':
        return '/cart/';
    case '/cart.html':
        return '/cart/';
    case '/challenge-coins':
        return '/challenge-coins/';
    case '/challenge-coins/index':
        return '/challenge-coins/';
    case '/challenge-coins/index.html':
        return '/challenge-coins/';
    case '/change-password':
        return '/change-password/';
    case '/change-password.html':
        return '/change-password/';
    case '/checkout':
        return '/checkout/';
    case '/checkout.html':
        return '/checkout/';
    case '/cloisonne':
        return '/cloisonne/';
    case '/cloisonne/index':
        return '/cloisonne/';
    case '/cloisonne/index.md':
        return '/cloisonne/';
    case '/components':
        return '/components/';
    case '/components.html':
        return '/components/';
    case '/components/img-partial':
        return '/components/img-partial/';
    case '/components/img-partial/index':
        return '/components/img-partial/';
    case '/components/img-partial/index.md':
        return '/components/img-partial/';
    case '/contact':
        return '/contact/';
    case '/contact.html':
        return '/contact/';
    case '/contact/success':
        return '/contact/success/';
    case '/contact/success.html':
        return '/contact/success/';
    case '/custom-pin-attachment-options':
        return '/custom-pin-attachment-options/';
    case '/custom-pin-attachment-options/index':
        return '/custom-pin-attachment-options/';
    case '/custom-pin-attachment-options/index.html':
        return '/custom-pin-attachment-options/';
    case '/custom-presentation-options':
        return '/custom-presentation-options/';
    case '/custom-presentation-options/index':
        return '/custom-presentation-options/';
    case '/custom-presentation-options/index.html':
        return '/custom-presentation-options/';
    case '/customer-reviews':
        return '/customer-reviews/';
    case '/customer-reviews.html':
        return '/customer-reviews/';
    case '/dashboard':
        return '/dashboard/';
    case '/dashboard.html':
        return '/dashboard/';
    case '/diestruck':
        return '/diestruck/';
    case '/diestruck/index':
        return '/diestruck/';
    case '/diestruck/index.md':
        return '/diestruck/';
    case '/dog-tags':
        return '/dog-tags/';
    case '/dog-tags/index':
        return '/dog-tags/';
    case '/dog-tags/index.html':
        return '/dog-tags/';
    case '/dye-sublimated':
        return '/dye-sublimated/';
    case '/dye-sublimated/index':
        return '/dye-sublimated/';
    case '/dye-sublimated/index.html':
        return '/dye-sublimated/';
    case '/employee-recognition-pins':
        return '/employee-recognition-pins/';
    case '/employee-recognition-pins/index':
        return '/employee-recognition-pins/';
    case '/employee-recognition-pins/index.html':
        return '/employee-recognition-pins/';
    case '/error':
        return '/error/';
    case '/error.html':
        return '/error/';
    case '/faq':
        return '/faq/';
    case '/faq.md':
        return '/faq/';
    case '/forgot':
        return '/forgot/';
    case '/forgot.html':
        return '/forgot/';
    case '/free-quote':
        return '/free-quote/';
    case '/free-quote.html':
        return '/free-quote/';
    case '/free-quote/details':
        return '/free-quote/details/';
    case '/free-quote/details.html':
        return '/free-quote/details/';
    case '/free-quote/in-depth':
        return '/free-quote/in-depth/';
    case '/free-quote/in-depth.html':
        return '/free-quote/in-depth/';
    case '/free-quote/review':
        return '/free-quote/review/';
    case '/free-quote/review.html':
        return '/free-quote/review/';
    case '/free-quote/thank-you':
        return '/free-quote/thank-you/';
    case '/free-quote/thank-you.html':
        return '/free-quote/thank-you/';
    case '/free-quote/upload':
        return '/free-quote/upload/';
    case '/free-quote/upload.html':
        return '/free-quote/upload/';
    case '/gallery':
        return '/gallery/';
    case '/gallery.html':
        return '/gallery/';
    case '/hat-pins':
        return '/hat-pins/';
    case '/hat-pins/index':
        return '/hat-pins/';
    case '/hat-pins/index.html':
        return '/hat-pins/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content':
        return '/index.json';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/_index':
        return '/index.json';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/_index.html':
        return '/index.json';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/account-settings':
        return '/account-settings/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/account-settings.html':
        return '/account-settings/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/all-pricing':
        return '/all-pricing/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/all-pricing.html':
        return '/all-pricing/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog':
        return '/blog/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog/_index':
        return '/blog/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/blog/_index.html':
        return '/blog/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/cart':
        return '/cart/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/cart.html':
        return '/cart/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/change-password':
        return '/change-password/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/change-password.html':
        return '/change-password/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/checkout':
        return '/checkout/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/checkout.html':
        return '/checkout/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial':
        return '/components/img-partial/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial/index':
        return '/components/img-partial/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/components/img-partial/index.md':
        return '/components/img-partial/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact':
        return '/contact/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact.html':
        return '/contact/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact/success':
        return '/contact/success/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/contact/success.html':
        return '/contact/success/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/customer-reviews':
        return '/customer-reviews/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/customer-reviews.html':
        return '/customer-reviews/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/dashboard':
        return '/dashboard/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/dashboard.html':
        return '/dashboard/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/error':
        return '/error/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/error.html':
        return '/error/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/forgot':
        return '/forgot/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/forgot.html':
        return '/forgot/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote':
        return '/free-quote/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote.html':
        return '/free-quote/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/details':
        return '/free-quote/details/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/details.html':
        return '/free-quote/details/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/in-depth':
        return '/free-quote/in-depth/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/in-depth.html':
        return '/free-quote/in-depth/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/review':
        return '/free-quote/review/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/review.html':
        return '/free-quote/review/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/thank-you':
        return '/free-quote/thank-you/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/thank-you.html':
        return '/free-quote/thank-you/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/upload':
        return '/free-quote/upload/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/free-quote/upload.html':
        return '/free-quote/upload/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/gallery':
        return '/gallery/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/gallery.html':
        return '/gallery/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/join':
        return '/join/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/join.html':
        return '/join/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login':
        return '/login/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login-email':
        return '/login-email/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login-email.html':
        return '/login-email/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/login.html':
        return '/login/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/order-submitted':
        return '/order-submitted/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/order-submitted.html':
        return '/order-submitted/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders':
        return '/orders/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders.html':
        return '/orders/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders/track':
        return '/orders/track/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/orders/track.html':
        return '/orders/track/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/password-reset':
        return '/password-reset/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/password-reset.html':
        return '/password-reset/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-history':
        return '/payment-history/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-history.html':
        return '/payment-history/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-methods':
        return '/payment-methods/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/payment-methods.html':
        return '/payment-methods/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/privacy':
        return '/privacy/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/privacy.md':
        return '/privacy/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quote':
        return '/quote/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quote.html':
        return '/quote/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quotes':
        return '/quotes/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/quotes.html':
        return '/quotes/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revision-requests':
        return '/revision-requests/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revision-requests.html':
        return '/revision-requests/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revisions':
        return '/revisions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/revisions.html':
        return '/revisions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/shipping-addresses':
        return '/shipping-addresses/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/shipping-addresses.html':
        return '/shipping-addresses/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tax-exemptions':
        return '/tax-exemptions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tax-exemptions.html':
        return '/tax-exemptions/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/terms':
        return '/terms/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/terms.md':
        return '/terms/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tracking':
        return '/tracking/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/tracking.html':
        return '/tracking/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/unsubscribed':
        return '/unsubscribed/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/unsubscribed.html':
        return '/unsubscribed/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/uploads':
        return '/uploads/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/allabout/content/uploads.html':
        return '/uploads/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components':
        return '/components/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index':
        return '/components/';
    case '/home/brian/actions-runner/_work/StirlingMarketingGroup/StirlingMarketingGroup/hugo/content/components/_index.md':
        return '/components/';
    case '/join':
        return '/join/';
    case '/join.html':
        return '/join/';
    case '/keychains':
        return '/keychains/';
    case '/keychains/index':
        return '/keychains/';
    case '/keychains/index.html':
        return '/keychains/';
    case '/login':
        return '/login/';
    case '/login-email':
        return '/login-email/';
    case '/login-email.html':
        return '/login-email/';
    case '/login.html':
        return '/login/';
    case '/medallions':
        return '/medallions/';
    case '/medallions/index':
        return '/medallions/';
    case '/medallions/index.html':
        return '/medallions/';
    case '/nylon':
        return '/nylon/';
    case '/nylon/index':
        return '/nylon/';
    case '/nylon/index.html':
        return '/nylon/';
    case '/offset-printed':
        return '/offset-printed/';
    case '/offset-printed/index':
        return '/offset-printed/';
    case '/offset-printed/index.md':
        return '/offset-printed/';
    case '/order-submitted':
        return '/order-submitted/';
    case '/order-submitted.html':
        return '/order-submitted/';
    case '/orders':
        return '/orders/';
    case '/orders.html':
        return '/orders/';
    case '/orders/track':
        return '/orders/track/';
    case '/orders/track.html':
        return '/orders/track/';
    case '/password-reset':
        return '/password-reset/';
    case '/password-reset.html':
        return '/password-reset/';
    case '/payment-history':
        return '/payment-history/';
    case '/payment-history.html':
        return '/payment-history/';
    case '/payment-methods':
        return '/payment-methods/';
    case '/payment-methods.html':
        return '/payment-methods/';
    case '/polyester':
        return '/polyester/';
    case '/polyester/index':
        return '/polyester/';
    case '/polyester/index.html':
        return '/polyester/';
    case '/presentation-options':
        return '/presentation-options/';
    case '/presentation-options/index':
        return '/presentation-options/';
    case '/presentation-options/index.html':
        return '/presentation-options/';
    case '/pricing':
        return '/pricing/';
    case '/pricing/index':
        return '/pricing/';
    case '/pricing/index.html':
        return '/pricing/';
    case '/privacy':
        return '/privacy/';
    case '/privacy.md':
        return '/privacy/';
    case '/pvc':
        return '/pvc/';
    case '/pvc/index':
        return '/pvc/';
    case '/pvc/index.html':
        return '/pvc/';
    case '/quote':
        return '/quote/';
    case '/quote.html':
        return '/quote/';
    case '/quotes':
        return '/quotes/';
    case '/quotes.html':
        return '/quotes/';
    case '/revision-requests':
        return '/revision-requests/';
    case '/revision-requests.html':
        return '/revision-requests/';
    case '/revisions':
        return '/revisions/';
    case '/revisions.html':
        return '/revisions/';
    case '/rush-pin-quote-form':
        return '/start-a-rush-trading-pin/';
    case '/rush-pin-quote-form/index':
        return '/start-a-rush-trading-pin/';
    case '/rush-pin-quote-form/index.html':
        return '/start-a-rush-trading-pin/';
    case '/shipping-addresses':
        return '/shipping-addresses/';
    case '/shipping-addresses.html':
        return '/shipping-addresses/';
    case '/silkscreen':
        return '/silkscreen/';
    case '/silkscreen/index':
        return '/silkscreen/';
    case '/silkscreen/index.md':
        return '/silkscreen/';
    case '/soft-enamel':
        return '/soft-enamel/';
    case '/soft-enamel/index':
        return '/soft-enamel/';
    case '/soft-enamel/index.md':
        return '/soft-enamel/';
    case '/tax-exemptions':
        return '/tax-exemptions/';
    case '/tax-exemptions.html':
        return '/tax-exemptions/';
    case '/terms':
        return '/terms/';
    case '/terms.md':
        return '/terms/';
    case '/thank-you':
        return '/thank-you/';
    case '/thank-you/index':
        return '/thank-you/';
    case '/thank-you/index.html':
        return '/thank-you/';
    case '/tracking':
        return '/tracking/';
    case '/tracking.html':
        return '/tracking/';
    case '/trading-pin-quote-form':
        return '/start-a-trading-pin/';
    case '/trading-pin-quote-form/index':
        return '/start-a-trading-pin/';
    case '/trading-pin-quote-form/index.html':
        return '/start-a-trading-pin/';
    case '/trading-pins':
        return '/trading-pins/';
    case '/trading-pins-delivery-options':
        return '/trading-pins-delivery-options/';
    case '/trading-pins-delivery-options/index':
        return '/trading-pins-delivery-options/';
    case '/trading-pins-delivery-options/index.html':
        return '/trading-pins-delivery-options/';
    case '/trading-pins/index':
        return '/trading-pins/';
    case '/trading-pins/index.md':
        return '/trading-pins/';
    case '/tube':
        return '/tube/';
    case '/tube/index':
        return '/tube/';
    case '/tube/index.html':
        return '/tube/';
    case '/unsubscribed':
        return '/unsubscribed/';
    case '/unsubscribed.html':
        return '/unsubscribed/';
    case '/uploads':
        return '/uploads/';
    case '/uploads.html':
        return '/uploads/';
    case '/usa-rush-trading-pins':
        return '/usa-rush-trading-pins/';
    case '/usa-rush-trading-pins/index':
        return '/usa-rush-trading-pins/';
    case '/usa-rush-trading-pins/index.html':
        return '/usa-rush-trading-pins/';
    case '/uses/corporate-coins':
        return '/corporate-coins/';
    case '/uses/corporate-coins/index':
        return '/corporate-coins/';
    case '/uses/corporate-coins/index.html':
        return '/corporate-coins/';
    case '/uses/ems-coins':
        return '/ems-coins/';
    case '/uses/ems-coins/index':
        return '/ems-coins/';
    case '/uses/ems-coins/index.html':
        return '/ems-coins/';
    case '/uses/entertainment-coins':
        return '/entertainment-coins/';
    case '/uses/entertainment-coins/index':
        return '/entertainment-coins/';
    case '/uses/entertainment-coins/index.html':
        return '/entertainment-coins/';
    case '/uses/firefighter-coins':
        return '/firefighter-coins/';
    case '/uses/firefighter-coins/index':
        return '/firefighter-coins/';
    case '/uses/firefighter-coins/index.html':
        return '/firefighter-coins/';
    case '/uses/freemason-coins':
        return '/freemason-coins/';
    case '/uses/freemason-coins/index':
        return '/freemason-coins/';
    case '/uses/freemason-coins/index.html':
        return '/freemason-coins/';
    case '/uses/government-coins':
        return '/government-coins/';
    case '/uses/government-coins/index':
        return '/government-coins/';
    case '/uses/government-coins/index.html':
        return '/government-coins/';
    case '/uses/international-coins':
        return '/international-coins/';
    case '/uses/international-coins/index':
        return '/international-coins/';
    case '/uses/international-coins/index.html':
        return '/international-coins/';
    case '/uses/military-coins':
        return '/military-coins/';
    case '/uses/military-coins/index':
        return '/military-coins/';
    case '/uses/military-coins/index.html':
        return '/military-coins/';
    case '/uses/police-coins':
        return '/police-coins/';
    case '/uses/police-coins/index':
        return '/police-coins/';
    case '/uses/police-coins/index.html':
        return '/police-coins/';
    case '/uses/school-coins':
        return '/school-coins/';
    case '/uses/school-coins/index':
        return '/school-coins/';
    case '/uses/school-coins/index.html':
        return '/school-coins/';
    case '/woven':
        return '/woven/';
    case '/woven/index':
        return '/woven/';
    case '/woven/index.html':
        return '/woven/';
    }
}
